var map = {
	"./CurrencyManagement": 1047,
	"./CurrencyManagement.js": 1047,
	"./TRM": 1048,
	"./TRM.js": 1048,
	"./TRM/filter": 173,
	"./TRM/filter.js": 173,
	"./TRM/table": 174,
	"./TRM/table.js": 174,
	"./accounting/accounts": 1049,
	"./accounting/accounts.js": 1049,
	"./accounting/accounts/filter": 175,
	"./accounting/accounts/filter.js": 175,
	"./accounting/accounts/table": 176,
	"./accounting/accounts/table.js": 176,
	"./accounting/area": 1050,
	"./accounting/area.js": 1050,
	"./accounting/area/filter": 1003,
	"./accounting/area/filter.js": 1003,
	"./accounting/area/table": 177,
	"./accounting/area/table.js": 177,
	"./accounting/area_copy": 1051,
	"./accounting/area_copy.js": 1051,
	"./accounting/closingDayReport": 1052,
	"./accounting/closingDayReport.js": 1052,
	"./accounting/closingDayReport/filter": 178,
	"./accounting/closingDayReport/filter.js": 178,
	"./accounting/closingDayReport/table": 179,
	"./accounting/closingDayReport/table.js": 179,
	"./accounting/concepts": 1053,
	"./accounting/concepts.js": 1053,
	"./accounting/concepts/filter": 180,
	"./accounting/concepts/filter.js": 180,
	"./accounting/concepts/table": 181,
	"./accounting/concepts/table.js": 181,
	"./accounting/costCenter": 1054,
	"./accounting/costCenter.js": 1054,
	"./accounting/costCenter/filter": 182,
	"./accounting/costCenter/filter.js": 182,
	"./accounting/costCenter/table": 183,
	"./accounting/costCenter/table.js": 183,
	"./accounting/employees": 1055,
	"./accounting/employees.js": 1055,
	"./accounting/employees/filter": 1004,
	"./accounting/employees/filter.js": 1004,
	"./accounting/employees/table": 184,
	"./accounting/employees/table.js": 184,
	"./accounting/expenses": 1056,
	"./accounting/expenses.js": 1056,
	"./accounting/expenses/filter": 185,
	"./accounting/expenses/filter.js": 185,
	"./accounting/expenses/table": 186,
	"./accounting/expenses/table.js": 186,
	"./accounting/incomes": 1057,
	"./accounting/incomes.js": 1057,
	"./accounting/incomes/filter": 187,
	"./accounting/incomes/filter.js": 187,
	"./accounting/incomes/table": 188,
	"./accounting/incomes/table.js": 188,
	"./accounting/position": 1058,
	"./accounting/position.js": 1058,
	"./accounting/position/filter": 1005,
	"./accounting/position/filter.js": 1005,
	"./accounting/position/table": 189,
	"./accounting/position/table.js": 189,
	"./accounting/productsThirdBetShop": 1059,
	"./accounting/productsThirdBetShop.js": 1059,
	"./accounting/productsThirdBetShop/filter": 1006,
	"./accounting/productsThirdBetShop/filter.js": 1006,
	"./accounting/productsThirdBetShop/table": 190,
	"./accounting/productsThirdBetShop/table.js": 190,
	"./accounting/productsThirdByBetShop": 1060,
	"./accounting/productsThirdByBetShop.js": 1060,
	"./accounting/productsThirdByBetShop/filter": 191,
	"./accounting/productsThirdByBetShop/filter.js": 191,
	"./accounting/productsThirdByBetShop/table": 192,
	"./accounting/productsThirdByBetShop/table.js": 192,
	"./accounting/productsThirdQuota": 1061,
	"./accounting/productsThirdQuota.js": 1061,
	"./accounting/productsThirdQuota/filter": 193,
	"./accounting/productsThirdQuota/filter.js": 193,
	"./accounting/productsThirdQuota/table": 194,
	"./accounting/productsThirdQuota/table.js": 194,
	"./accounting/providers": 1062,
	"./accounting/providers.js": 1062,
	"./accounting/providers/filter": 1007,
	"./accounting/providers/filter.js": 1007,
	"./accounting/providers/table": 195,
	"./accounting/providers/table.js": 195,
	"./accounting/providers/tableProductsThirdBetShop": 1063,
	"./accounting/providers/tableProductsThirdBetShop.js": 1063,
	"./accounting/providers_copy": 1064,
	"./accounting/providers_copy.js": 1064,
	"./accounting/squareDayReport": 1065,
	"./accounting/squareDayReport.js": 1065,
	"./accounting/squareDayReport/filter": 196,
	"./accounting/squareDayReport/filter.js": 196,
	"./accounting/squareDayReport/table": 197,
	"./accounting/squareDayReport/table.js": 197,
	"./accounting/squareDayReport2": 1066,
	"./accounting/squareDayReport2.js": 1066,
	"./accounting/squareDayReport2/filter": 198,
	"./accounting/squareDayReport2/filter.js": 198,
	"./accounting/squareDayReport2/table": 199,
	"./accounting/squareDayReport2/table.js": 199,
	"./accounting/typeCenterPosition": 1067,
	"./accounting/typeCenterPosition.js": 1067,
	"./accounting/typeDocument": 1068,
	"./accounting/typeDocument.js": 1068,
	"./accounting/typeDocument/filter": 201,
	"./accounting/typeDocument/filter.js": 201,
	"./accounting/typeDocument/table": 202,
	"./accounting/typeDocument/table.js": 202,
	"./accounting/types/filter": 1008,
	"./accounting/types/filter.js": 1008,
	"./accounting/types/table": 200,
	"./accounting/types/table.js": 200,
	"./activateRegistration": 1069,
	"./activateRegistration.js": 1069,
	"./activeProviders": 1070,
	"./activeProviders.js": 1070,
	"./addAdminUserManagement": 1071,
	"./addAdminUserManagement.js": 1071,
	"./addAgentListManagement": 1072,
	"./addAgentListManagement.js": 1072,
	"./addBetShopManagement": 1073,
	"./addBetShopManagement.js": 1073,
	"./adminUser": 1074,
	"./adminUser.js": 1074,
	"./adminUserManagement": 1075,
	"./adminUserManagement.js": 1075,
	"./affiliatesBetShop": 1076,
	"./affiliatesBetShop.js": 1076,
	"./agent/addInformationAgentList": 1077,
	"./agent/addInformationAgentList.js": 1077,
	"./agent/age": 1078,
	"./agent/age.js": 1078,
	"./agent/agent-list/detailsAgentList": 211,
	"./agent/agent-list/detailsAgentList.js": 211,
	"./agent/agent-list/filterAgentList": 212,
	"./agent/agent-list/filterAgentList.js": 212,
	"./agent/agent-list/recordAgentList": 213,
	"./agent/agent-list/recordAgentList.js": 213,
	"./agent/agent-list/recordTableAgentList": 1009,
	"./agent/agent-list/recordTableAgentList.js": 1009,
	"./agent/agent-list/tableAgentList": 214,
	"./agent/agent-list/tableAgentList.js": 214,
	"./agent/agent-retraction/PagoPremio": 215,
	"./agent/agent-retraction/PagoPremio.js": 215,
	"./agent/agent-retraction/search": 216,
	"./agent/agent-retraction/search.js": 216,
	"./agent/agent-retraction/transfers": 217,
	"./agent/agent-retraction/transfers.js": 217,
	"./agent/agent-retraction/transfers1": 218,
	"./agent/agent-retraction/transfers1.js": 218,
	"./agent/agent-transfers/PagoPremio": 219,
	"./agent/agent-transfers/PagoPremio.js": 219,
	"./agent/agent-transfers/search": 220,
	"./agent/agent-transfers/search.js": 220,
	"./agent/agent-transfers/transfers": 221,
	"./agent/agent-transfers/transfers.js": 221,
	"./agent/agent-transfers/transfers1": 222,
	"./agent/agent-transfers/transfers1.js": 222,
	"./agent/agent-tree/details": 1010,
	"./agent/agent-tree/details.js": 1010,
	"./agent/agent-tree/filter": 223,
	"./agent/agent-tree/filter.js": 223,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 224,
	"./agent/agent-tree/recordTableAgentList.js": 224,
	"./agent/agent-tree/table": 225,
	"./agent/agent-tree/table.js": 225,
	"./agent/bonusReportAgentList": 1079,
	"./agent/bonusReportAgentList.js": 1079,
	"./agent/casinoGamesReportAgentList": 1080,
	"./agent/casinoGamesReportAgentList.js": 1080,
	"./agent/comissions": 1081,
	"./agent/comissions.js": 1081,
	"./agent/comissions/autoexclusionUsers": 1082,
	"./agent/comissions/autoexclusionUsers.js": 1082,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1083,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1083,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1084,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1084,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1085,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1085,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1086,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1086,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1087,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1087,
	"./agent/comissions/betsReport/detailsReport": 1088,
	"./agent/comissions/betsReport/detailsReport.js": 1088,
	"./agent/comissions/betsReport/filterReport": 1089,
	"./agent/comissions/betsReport/filterReport.js": 1089,
	"./agent/comissions/betsReport/recordReport": 1090,
	"./agent/comissions/betsReport/recordReport.js": 1090,
	"./agent/comissions/betsReport/recordTableReport": 1091,
	"./agent/comissions/betsReport/recordTableReport.js": 1091,
	"./agent/comissions/betsReport/recordTableTransReport": 1092,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1092,
	"./agent/comissions/betsReport/recordTransReport": 1093,
	"./agent/comissions/betsReport/recordTransReport.js": 1093,
	"./agent/comissions/betsReport/tableReport": 1094,
	"./agent/comissions/betsReport/tableReport.js": 1094,
	"./agent/comissions/betsReportBetShop": 1095,
	"./agent/comissions/betsReportBetShop.js": 1095,
	"./agent/comissions/bonusReport/detailsBonusReport": 1096,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1096,
	"./agent/comissions/bonusReport/filterBonusReport": 1097,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1097,
	"./agent/comissions/bonusReport/recordBonusReport": 1098,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1098,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1099,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1099,
	"./agent/comissions/bonusReport/tableBonusReport": 1100,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1100,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1101,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1101,
	"./agent/comissions/casinoReport/filterCasinoReport": 1102,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1102,
	"./agent/comissions/casinoReport/recordCasinoReport": 1103,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1103,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1104,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1104,
	"./agent/comissions/casinoReport/tableCasinoReport": 1105,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1105,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1106,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1106,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1107,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1107,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1108,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1108,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1109,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1109,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1110,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1110,
	"./agent/comissions/comissions": 1111,
	"./agent/comissions/comissions.js": 1111,
	"./agent/comissions/comissions/table": 234,
	"./agent/comissions/comissions/table.js": 234,
	"./agent/comissions/comissionsReportBetShop": 1112,
	"./agent/comissions/comissionsReportBetShop.js": 1112,
	"./agent/comissions/comissionsReportBetShopDetail": 1113,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1113,
	"./agent/comissions/comissions_report/detailsDepositReports": 1114,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1114,
	"./agent/comissions/comissions_report/filter": 235,
	"./agent/comissions/comissions_report/filter.js": 235,
	"./agent/comissions/comissions_report/recordDepositReports": 1115,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1115,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1116,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1116,
	"./agent/comissions/comissions_report/table": 236,
	"./agent/comissions/comissions_report/table.js": 236,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1117,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1117,
	"./agent/comissions/comissions_report_detail/filter": 237,
	"./agent/comissions/comissions_report_detail/filter.js": 237,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1118,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1118,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1119,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1119,
	"./agent/comissions/comissions_report_detail/table": 238,
	"./agent/comissions/comissions_report_detail/table.js": 238,
	"./agent/comissions/expenses": 1120,
	"./agent/comissions/expenses.js": 1120,
	"./agent/comissions/expenses/filter": 1121,
	"./agent/comissions/expenses/filter.js": 1121,
	"./agent/comissions/expenses/table": 1122,
	"./agent/comissions/expenses/table.js": 1122,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1123,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1123,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1124,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1124,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1125,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1125,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1126,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1126,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1127,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1127,
	"./agent/comissions/incomes": 1128,
	"./agent/comissions/incomes.js": 1128,
	"./agent/comissions/incomes/filter": 1129,
	"./agent/comissions/incomes/filter.js": 1129,
	"./agent/comissions/incomes/table": 1130,
	"./agent/comissions/incomes/table.js": 1130,
	"./agent/comissions/productsThird": 1131,
	"./agent/comissions/productsThird.js": 1131,
	"./agent/comissions/productsThird/filter": 1132,
	"./agent/comissions/productsThird/filter.js": 1132,
	"./agent/comissions/productsThird/table": 1133,
	"./agent/comissions/productsThird/table.js": 1133,
	"./agent/comissions/promotionalCodes": 1134,
	"./agent/comissions/promotionalCodes.js": 1134,
	"./agent/comissions/promotionalCodes/filter": 1135,
	"./agent/comissions/promotionalCodes/filter.js": 1135,
	"./agent/comissions/promotionalCodes/table": 1136,
	"./agent/comissions/promotionalCodes/table.js": 1136,
	"./agent/comissions/withdrawalRequests": 1137,
	"./agent/comissions/withdrawalRequests.js": 1137,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 241,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 241,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 239,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1138,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1138,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 242,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 242,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 240,
	"./agent/configuration/changePassword": 1139,
	"./agent/configuration/changePassword.js": 1139,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1140,
	"./agent/configuration/generateToken.js": 1140,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1141,
	"./agent/configuration/qrgoogle.js": 1141,
	"./agent/configuration/securityChanges": 1142,
	"./agent/configuration/securityChanges.js": 1142,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1143,
	"./agent/configurationAgentList.js": 1143,
	"./agent/depositReportAgentList": 1144,
	"./agent/depositReportAgentList.js": 1144,
	"./agent/financescustomerAgentList": 1145,
	"./agent/financescustomerAgentList.js": 1145,
	"./agent/financial/comisiones": 1146,
	"./agent/financial/comisiones.js": 1146,
	"./agent/financial/comisiones/table": 245,
	"./agent/financial/comisiones/table.js": 245,
	"./agent/financial/informationFinancialAgentList": 1147,
	"./agent/financial/informationFinancialAgentList.js": 1147,
	"./agent/financial/withdrawalRequestsAgentList": 1148,
	"./agent/financial/withdrawalRequestsAgentList.js": 1148,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 246,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 246,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1149,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1149,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 247,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 247,
	"./agent/flujoCajaAgentList": 1150,
	"./agent/flujoCajaAgentList.js": 1150,
	"./agent/flujoCajaHijosAgentList": 1151,
	"./agent/flujoCajaHijosAgentList.js": 1151,
	"./agent/geo": 1152,
	"./agent/geo.js": 1152,
	"./agent/informationAgentList": 1153,
	"./agent/informationAgentList.js": 1153,
	"./agent/informeRed/details": 1154,
	"./agent/informeRed/details.js": 1154,
	"./agent/informeRed/filter": 254,
	"./agent/informeRed/filter.js": 254,
	"./agent/informeRed/record": 1155,
	"./agent/informeRed/record.js": 1155,
	"./agent/informeRed/recordTable": 1156,
	"./agent/informeRed/recordTable.js": 1156,
	"./agent/informeRed/table": 255,
	"./agent/informeRed/table.js": 255,
	"./agent/money": 1157,
	"./agent/money.js": 1157,
	"./agent/paymenthistory": 1158,
	"./agent/paymenthistory.js": 1158,
	"./agent/positions": 1159,
	"./agent/positions.js": 1159,
	"./agent/reports/autoexclusionUsers": 1160,
	"./agent/reports/autoexclusionUsers.js": 1160,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1161,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1161,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1162,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1162,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1163,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1163,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1164,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1164,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1165,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1165,
	"./agent/reports/balanceTransactionReport": 1166,
	"./agent/reports/balanceTransactionReport.js": 1166,
	"./agent/reports/balanceTransactionReport/filter": 256,
	"./agent/reports/balanceTransactionReport/filter.js": 256,
	"./agent/reports/balanceTransactionReport/table": 257,
	"./agent/reports/balanceTransactionReport/table.js": 257,
	"./agent/reports/betsReport/detailsReport": 1167,
	"./agent/reports/betsReport/detailsReport.js": 1167,
	"./agent/reports/betsReport/filterReport": 258,
	"./agent/reports/betsReport/filterReport.js": 258,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1168,
	"./agent/reports/betsReport/recordTableReport.js": 1168,
	"./agent/reports/betsReport/recordTableTransReport": 1169,
	"./agent/reports/betsReport/recordTableTransReport.js": 1169,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 259,
	"./agent/reports/betsReport/tableReport.js": 259,
	"./agent/reports/betsReportAgentList": 1170,
	"./agent/reports/betsReportAgentList.js": 1170,
	"./agent/reports/bonusReport/detailsBonusReport": 228,
	"./agent/reports/bonusReport/detailsBonusReport.js": 228,
	"./agent/reports/bonusReport/filterBonusReport": 226,
	"./agent/reports/bonusReport/filterBonusReport.js": 226,
	"./agent/reports/bonusReport/recordBonusReport": 229,
	"./agent/reports/bonusReport/recordBonusReport.js": 229,
	"./agent/reports/bonusReport/recordTableBonusReport": 1171,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1171,
	"./agent/reports/bonusReport/tableBonusReport": 227,
	"./agent/reports/bonusReport/tableBonusReport.js": 227,
	"./agent/reports/casinoReport/detailsCasinoReport": 232,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 232,
	"./agent/reports/casinoReport/filterCasinoReport": 230,
	"./agent/reports/casinoReport/filterCasinoReport.js": 230,
	"./agent/reports/casinoReport/recordCasinoReport": 233,
	"./agent/reports/casinoReport/recordCasinoReport.js": 233,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1172,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1172,
	"./agent/reports/casinoReport/tableCasinoReport": 231,
	"./agent/reports/casinoReport/tableCasinoReport.js": 231,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1173,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1173,
	"./agent/reports/casinoReport2/filterCasinoReport": 1174,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1174,
	"./agent/reports/casinoReport2/recordCasinoReport": 1175,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1175,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1176,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1176,
	"./agent/reports/casinoReport2/tableCasinoReport": 1177,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1177,
	"./agent/reports/deposit_report/detailsDepositReports": 1178,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1178,
	"./agent/reports/deposit_report/filterDepositReports": 243,
	"./agent/reports/deposit_report/filterDepositReports.js": 243,
	"./agent/reports/deposit_report/recordDepositReports": 1179,
	"./agent/reports/deposit_report/recordDepositReports.js": 1179,
	"./agent/reports/deposit_report/recordTableDepositReports": 1180,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1180,
	"./agent/reports/deposit_report/tableDepositReports": 244,
	"./agent/reports/deposit_report/tableDepositReports.js": 244,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1181,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1181,
	"./agent/reports/flujocaja/filterFlujoCaja": 248,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 248,
	"./agent/reports/flujocaja/recordFlujoCaja": 1182,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1182,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1183,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1183,
	"./agent/reports/flujocaja/tableFlujoCaja": 249,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 249,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 252,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 253,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1184,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1184,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 251,
	"./agent/reports/managementReport": 1185,
	"./agent/reports/managementReport.js": 1185,
	"./agent/reports/managementReport/filterReports": 260,
	"./agent/reports/managementReport/filterReports.js": 260,
	"./agent/reports/managementReport/tableReports": 261,
	"./agent/reports/managementReport/tableReports.js": 261,
	"./agent/reports/marketing/filterReports": 262,
	"./agent/reports/marketing/filterReports.js": 262,
	"./agent/reports/marketing/tableReports": 263,
	"./agent/reports/marketing/tableReports.js": 263,
	"./agent/reports/marketingReport": 1186,
	"./agent/reports/marketingReport.js": 1186,
	"./agent/reports/promotionalCodes": 1187,
	"./agent/reports/promotionalCodes.js": 1187,
	"./agent/reports/promotionalCodes/filter": 264,
	"./agent/reports/promotionalCodes/filter.js": 264,
	"./agent/reports/promotionalCodes/table": 265,
	"./agent/reports/promotionalCodes/table.js": 265,
	"./agent/reports/quotaRetractionReport/filter": 266,
	"./agent/reports/quotaRetractionReport/filter.js": 266,
	"./agent/reports/quotaRetractionReport/table": 267,
	"./agent/reports/quotaRetractionReport/table.js": 267,
	"./agent/reports/quotaRetractionReportAgent": 1188,
	"./agent/reports/quotaRetractionReportAgent.js": 1188,
	"./agent/reports/transfersReport/filter": 268,
	"./agent/reports/transfersReport/filter.js": 268,
	"./agent/reports/transfersReport/table": 269,
	"./agent/reports/transfersReport/table.js": 269,
	"./agent/reports/trasnfersReport": 1189,
	"./agent/reports/trasnfersReport.js": 1189,
	"./agent/reports/userAfilliatesReport": 1190,
	"./agent/reports/userAfilliatesReport.js": 1190,
	"./agent/reports/user_affiliates/detailsReports": 272,
	"./agent/reports/user_affiliates/detailsReports.js": 272,
	"./agent/reports/user_affiliates/filterReports": 270,
	"./agent/reports/user_affiliates/filterReports.js": 270,
	"./agent/reports/user_affiliates/recordReports": 273,
	"./agent/reports/user_affiliates/recordReports.js": 273,
	"./agent/reports/user_affiliates/recordTableReports": 1191,
	"./agent/reports/user_affiliates/recordTableReports.js": 1191,
	"./agent/reports/user_affiliates/tableReports": 271,
	"./agent/reports/user_affiliates/tableReports.js": 271,
	"./agent/reportscustomerAgentList": 1192,
	"./agent/reportscustomerAgentList.js": 1192,
	"./agent/requestsAgent": 1193,
	"./agent/requestsAgent.js": 1193,
	"./agent/requestsAgent/filter": 274,
	"./agent/requestsAgent/filter.js": 274,
	"./agent/requestsAgent/table": 275,
	"./agent/requestsAgent/table.js": 275,
	"./agent/requirementsAgent": 1194,
	"./agent/requirementsAgent.js": 1194,
	"./agent/requirementsAgent/details": 278,
	"./agent/requirementsAgent/details.js": 278,
	"./agent/requirementsAgent/detailsFilter": 280,
	"./agent/requirementsAgent/detailsFilter.js": 280,
	"./agent/requirementsAgent/detailsTable": 279,
	"./agent/requirementsAgent/detailsTable.js": 279,
	"./agent/requirementsAgent/filter": 276,
	"./agent/requirementsAgent/filter.js": 276,
	"./agent/requirementsAgent/table": 277,
	"./agent/requirementsAgent/table.js": 277,
	"./agent/statistics/age": 281,
	"./agent/statistics/age.js": 281,
	"./agent/statistics/marketing": 282,
	"./agent/statistics/marketing.js": 282,
	"./agent/statistics/marketingvsregistros": 283,
	"./agent/statistics/marketingvsregistros.js": 283,
	"./agent/statistics/money": 284,
	"./agent/statistics/money.js": 284,
	"./agent/statisticsAgentList": 1195,
	"./agent/statisticsAgentList.js": 1195,
	"./agent/tags": 1196,
	"./agent/tags.js": 1196,
	"./agentList": 1197,
	"./agentList.js": 1197,
	"./agentListManagement": 1198,
	"./agentListManagement.js": 1198,
	"./agentRetraction": 1199,
	"./agentRetraction.js": 1199,
	"./agentTransfers": 1200,
	"./agentTransfers.js": 1200,
	"./agentsInform": 1201,
	"./agentsInform.js": 1201,
	"./agentsTree": 1202,
	"./agentsTree.js": 1202,
	"./alltactions": 285,
	"./alltactions.js": 285,
	"./approvalLogs": 1203,
	"./approvalLogs.js": 1203,
	"./approvalLogs2": 1204,
	"./approvalLogs2.js": 1204,
	"./approvalLogsBetShop": 1205,
	"./approvalLogsBetShop.js": 1205,
	"./assignmentQuotaMade": 1206,
	"./assignmentQuotaMade.js": 1206,
	"./assignmentQuotaR": 1207,
	"./assignmentQuotaR.js": 1207,
	"./autoexclusionUsers": 1208,
	"./autoexclusionUsers.js": 1208,
	"./balanceAdjustments": 1209,
	"./balanceAdjustments.js": 1209,
	"./balanceHistory": 1210,
	"./balanceHistory.js": 1210,
	"./balanceHistory2": 1211,
	"./balanceHistory2.js": 1211,
	"./balanceHistoryAdminUser": 1212,
	"./balanceHistoryAdminUser.js": 1212,
	"./balanceHistoryBetShop": 1213,
	"./balanceHistoryBetShop.js": 1213,
	"./balanceHistoryBetShop2": 1214,
	"./balanceHistoryBetShop2.js": 1214,
	"./balanceHistoryForAgent": 1215,
	"./balanceHistoryForAgent.js": 1215,
	"./balanceHistoryForBetShop": 1216,
	"./balanceHistoryForBetShop.js": 1216,
	"./balanceHistoryMachine": 1217,
	"./balanceHistoryMachine.js": 1217,
	"./balanceUsers": 1218,
	"./balanceUsers.js": 1218,
	"./bankAccounts": 1219,
	"./bankAccounts.js": 1219,
	"./banks": 1220,
	"./banks.js": 1220,
	"./betShop": 1221,
	"./betShop.js": 1221,
	"./betShopCompetence": 1222,
	"./betShopCompetence.js": 1222,
	"./betShopManagement": 1223,
	"./betShopManagement.js": 1223,
	"./betShopManagement/addInformationBetShop": 1224,
	"./betShopManagement/addInformationBetShop.js": 1224,
	"./betShopManagement/age": 1225,
	"./betShopManagement/age.js": 1225,
	"./betShopManagement/betShop/detailsBetShop": 1011,
	"./betShopManagement/betShop/detailsBetShop.js": 1011,
	"./betShopManagement/betShop/filterBetShop": 326,
	"./betShopManagement/betShop/filterBetShop.js": 326,
	"./betShopManagement/betShop/recordBetShop": 328,
	"./betShopManagement/betShop/recordBetShop.js": 328,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 327,
	"./betShopManagement/betShop/tableBetShop.js": 327,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1226,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1226,
	"./betShopManagement/betShopCompetence/filterBetShop": 329,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 329,
	"./betShopManagement/betShopCompetence/recordBetShop": 1227,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1227,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1228,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1228,
	"./betShopManagement/betShopCompetence/tableBetShop": 330,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 330,
	"./betShopManagement/bonusReportBetShop": 1229,
	"./betShopManagement/bonusReportBetShop.js": 1229,
	"./betShopManagement/cashier/betShopAdvertising": 335,
	"./betShopManagement/cashier/betShopAdvertising.js": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 337,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 337,
	"./betShopManagement/cashier/betShopCashier": 1230,
	"./betShopManagement/cashier/betShopCashier.js": 1230,
	"./betShopManagement/cashier/betShopComissions": 1012,
	"./betShopManagement/cashier/betShopComissions.js": 1012,
	"./betShopManagement/cashier/filterCashier": 340,
	"./betShopManagement/cashier/filterCashier.js": 340,
	"./betShopManagement/cashier/tableAdvertising": 336,
	"./betShopManagement/cashier/tableAdvertising.js": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier": 338,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 338,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 339,
	"./betShopManagement/cashier/tableComissions.js": 339,
	"./betShopManagement/casinoGamesReportBetShop": 1231,
	"./betShopManagement/casinoGamesReportBetShop.js": 1231,
	"./betShopManagement/comissions": 1232,
	"./betShopManagement/comissions.js": 1232,
	"./betShopManagement/comissions/autoexclusionUsers": 1233,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1233,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1234,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1234,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1235,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1235,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1238,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1238,
	"./betShopManagement/comissions/betsReport/detailsReport": 1239,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1239,
	"./betShopManagement/comissions/betsReport/filterReport": 1240,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1240,
	"./betShopManagement/comissions/betsReport/recordReport": 1241,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1241,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1242,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1242,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1243,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1243,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1244,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1244,
	"./betShopManagement/comissions/betsReport/tableReport": 1245,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1245,
	"./betShopManagement/comissions/betsReportBetShop": 1246,
	"./betShopManagement/comissions/betsReportBetShop.js": 1246,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1247,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1247,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1248,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1248,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1249,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1249,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1250,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1250,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1251,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1251,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1252,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1252,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1253,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1253,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1254,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1254,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1255,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1255,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1256,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1256,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1257,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1257,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1258,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1258,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1259,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1259,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1260,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1260,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1261,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1261,
	"./betShopManagement/comissions/comissions": 1262,
	"./betShopManagement/comissions/comissions.js": 1262,
	"./betShopManagement/comissions/comissions/table": 345,
	"./betShopManagement/comissions/comissions/table.js": 345,
	"./betShopManagement/comissions/comissionsReportBetShop": 1263,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1263,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1264,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1264,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1265,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1265,
	"./betShopManagement/comissions/comissions_report/filter": 346,
	"./betShopManagement/comissions/comissions_report/filter.js": 346,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1266,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1266,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1267,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1267,
	"./betShopManagement/comissions/comissions_report/table": 347,
	"./betShopManagement/comissions/comissions_report/table.js": 347,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1268,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1268,
	"./betShopManagement/comissions/comissions_report_detail/filter": 348,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 348,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1269,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1269,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1270,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1270,
	"./betShopManagement/comissions/comissions_report_detail/table": 349,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 349,
	"./betShopManagement/comissions/expenses": 1271,
	"./betShopManagement/comissions/expenses.js": 1271,
	"./betShopManagement/comissions/expenses/filter": 1272,
	"./betShopManagement/comissions/expenses/filter.js": 1272,
	"./betShopManagement/comissions/expenses/table": 1273,
	"./betShopManagement/comissions/expenses/table.js": 1273,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1274,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1274,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1275,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1275,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1276,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1276,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1277,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1277,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1278,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1278,
	"./betShopManagement/comissions/incomes": 1279,
	"./betShopManagement/comissions/incomes.js": 1279,
	"./betShopManagement/comissions/incomes/filter": 1280,
	"./betShopManagement/comissions/incomes/filter.js": 1280,
	"./betShopManagement/comissions/incomes/table": 1281,
	"./betShopManagement/comissions/incomes/table.js": 1281,
	"./betShopManagement/comissions/productsThird": 1282,
	"./betShopManagement/comissions/productsThird.js": 1282,
	"./betShopManagement/comissions/productsThird/filter": 1283,
	"./betShopManagement/comissions/productsThird/filter.js": 1283,
	"./betShopManagement/comissions/productsThird/table": 1284,
	"./betShopManagement/comissions/productsThird/table.js": 1284,
	"./betShopManagement/comissions/promotionalCodes": 1285,
	"./betShopManagement/comissions/promotionalCodes.js": 1285,
	"./betShopManagement/comissions/promotionalCodes/filter": 1286,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1286,
	"./betShopManagement/comissions/promotionalCodes/table": 1287,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1287,
	"./betShopManagement/comissions/withdrawalRequests": 1288,
	"./betShopManagement/comissions/withdrawalRequests.js": 1288,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 352,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 352,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1289,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1289,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 353,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 353,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 351,
	"./betShopManagement/configuration/changePassword": 1290,
	"./betShopManagement/configuration/changePassword.js": 1290,
	"./betShopManagement/configuration/changePassword/changePasswordView": 354,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 354,
	"./betShopManagement/configuration/configNtc": 1291,
	"./betShopManagement/configuration/configNtc.js": 1291,
	"./betShopManagement/configuration/configNtc/configNtcView": 355,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 355,
	"./betShopManagement/configuration/generateToken": 1292,
	"./betShopManagement/configuration/generateToken.js": 1292,
	"./betShopManagement/configuration/generateToken/filter": 356,
	"./betShopManagement/configuration/generateToken/filter.js": 356,
	"./betShopManagement/configuration/generateToken/table": 357,
	"./betShopManagement/configuration/generateToken/table.js": 357,
	"./betShopManagement/configuration/qrgoogle": 1293,
	"./betShopManagement/configuration/qrgoogle.js": 1293,
	"./betShopManagement/configuration/securityChanges": 1294,
	"./betShopManagement/configuration/securityChanges.js": 1294,
	"./betShopManagement/configuration/securityChanges/filter": 1013,
	"./betShopManagement/configuration/securityChanges/filter.js": 1013,
	"./betShopManagement/configuration/securityChanges/table": 358,
	"./betShopManagement/configuration/securityChanges/table.js": 358,
	"./betShopManagement/configurationBetShop": 1295,
	"./betShopManagement/configurationBetShop.js": 1295,
	"./betShopManagement/depositReportBetShop": 1296,
	"./betShopManagement/depositReportBetShop.js": 1296,
	"./betShopManagement/financescustomerBetShop": 1297,
	"./betShopManagement/financescustomerBetShop.js": 1297,
	"./betShopManagement/financial/bankAccountsBetShop": 1298,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1298,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1299,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1299,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 361,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 361,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1300,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1300,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1301,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1301,
	"./betShopManagement/financial/bankAccountsBetShop/table": 362,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 362,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1302,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1302,
	"./betShopManagement/financial/informationFinancialBetShop": 1303,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1303,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1304,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1304,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 364,
	"./betShopManagement/flujoCajaBetShop": 1305,
	"./betShopManagement/flujoCajaBetShop.js": 1305,
	"./betShopManagement/geo": 1306,
	"./betShopManagement/geo.js": 1306,
	"./betShopManagement/informationBetShop": 1307,
	"./betShopManagement/informationBetShop.js": 1307,
	"./betShopManagement/money": 1308,
	"./betShopManagement/money.js": 1308,
	"./betShopManagement/paymenthistory": 1309,
	"./betShopManagement/paymenthistory.js": 1309,
	"./betShopManagement/positions": 1310,
	"./betShopManagement/positions.js": 1310,
	"./betShopManagement/reports/autoexclusionUsers": 1311,
	"./betShopManagement/reports/autoexclusionUsers.js": 1311,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1312,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1312,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1313,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1313,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1314,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1314,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1315,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1315,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1316,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1316,
	"./betShopManagement/reports/balanceTransactionReport": 1317,
	"./betShopManagement/reports/balanceTransactionReport.js": 1317,
	"./betShopManagement/reports/balanceTransactionReport/filter": 368,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 368,
	"./betShopManagement/reports/balanceTransactionReport/table": 369,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 369,
	"./betShopManagement/reports/betsReport/detailsReport": 1318,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1318,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1319,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1319,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1320,
	"./betShopManagement/reports/betsReportBetShop.js": 1320,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 333,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 333,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 334,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 334,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1321,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1321,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 332,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 332,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1322,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1322,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1323,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1323,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1324,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1324,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1325,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1325,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1326,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1326,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1327,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1327,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1014,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1014,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 359,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 359,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1328,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1328,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 360,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 360,
	"./betShopManagement/reports/expenses": 1329,
	"./betShopManagement/reports/expenses.js": 1329,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1330,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1330,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 366,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 366,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1331,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1331,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1332,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1332,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 367,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 367,
	"./betShopManagement/reports/historyMovement": 1333,
	"./betShopManagement/reports/historyMovement.js": 1333,
	"./betShopManagement/reports/historyMovement/filter": 370,
	"./betShopManagement/reports/historyMovement/filter.js": 370,
	"./betShopManagement/reports/historyMovement/table": 371,
	"./betShopManagement/reports/historyMovement/table.js": 371,
	"./betShopManagement/reports/incomes": 1334,
	"./betShopManagement/reports/incomes.js": 1334,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1335,
	"./betShopManagement/reports/productsThird.js": 1335,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1336,
	"./betShopManagement/reports/promotionalCodes.js": 1336,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1337,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1337,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 373,
	"./betShopManagement/reportscustomerBetShop": 1338,
	"./betShopManagement/reportscustomerBetShop.js": 1338,
	"./betShopManagement/statisticsBetShop": 1339,
	"./betShopManagement/statisticsBetShop.js": 1339,
	"./betShopManagement/tags": 1340,
	"./betShopManagement/tags.js": 1340,
	"./betsHistory": 1341,
	"./betsHistory.js": 1341,
	"./betsHistory2": 1342,
	"./betsHistory2.js": 1342,
	"./betsReport": 1343,
	"./betsReport.js": 1343,
	"./betsReportBetShop": 1344,
	"./betsReportBetShop.js": 1344,
	"./betsReportSecond": 1345,
	"./betsReportSecond.js": 1345,
	"./betsSport": 1346,
	"./betsSport.js": 1346,
	"./betsSportLive": 1347,
	"./betsSportLive.js": 1347,
	"./betsVirtual": 1348,
	"./betsVirtual.js": 1348,
	"./betting": 1349,
	"./betting.js": 1349,
	"./bettingVirtual": 1350,
	"./bettingVirtual.js": 1350,
	"./blockchains": 1351,
	"./blockchains.js": 1351,
	"./bonusReport": 1352,
	"./bonusReport.js": 1352,
	"./bonusReport2": 1353,
	"./bonusReport2.js": 1353,
	"./bonusReports2": 1354,
	"./bonusReports2.js": 1354,
	"./cash/bankAccounts/filter": 321,
	"./cash/bankAccounts/filter.js": 321,
	"./cash/bankAccounts/table": 322,
	"./cash/bankAccounts/table.js": 322,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1355,
	"./cash/bets/betHistory2.js": 1355,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 378,
	"./cash/bets/sportLive.js": 378,
	"./cash/bets/sportVirtual": 379,
	"./cash/bets/sportVirtual.js": 379,
	"./cash/closeBox-edit/creditCards": 388,
	"./cash/closeBox-edit/creditCards.js": 388,
	"./cash/closeBox-edit/otherExpenses": 389,
	"./cash/closeBox-edit/otherExpenses.js": 389,
	"./cash/closeBox-edit/otherIncome": 390,
	"./cash/closeBox-edit/otherIncome.js": 390,
	"./cash/closeBox-edit/products": 391,
	"./cash/closeBox-edit/products.js": 391,
	"./cash/closeBox-edit/total": 392,
	"./cash/closeBox-edit/total.js": 392,
	"./cash/closeBox-old/otherExpenses": 1356,
	"./cash/closeBox-old/otherExpenses.js": 1356,
	"./cash/closeBox-old/otherIncome": 1357,
	"./cash/closeBox-old/otherIncome.js": 1357,
	"./cash/closeBox-old/products": 1358,
	"./cash/closeBox-old/products.js": 1358,
	"./cash/closeBox-old/total": 1359,
	"./cash/closeBox-old/total.js": 1359,
	"./cash/closeBox/creditCards": 393,
	"./cash/closeBox/creditCards.js": 393,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 394,
	"./cash/flujocaja/detailsFlujoCaja.js": 394,
	"./cash/flujocaja/filterFlujoCaja": 395,
	"./cash/flujocaja/filterFlujoCaja.js": 395,
	"./cash/flujocaja/recordFlujoCaja": 396,
	"./cash/flujocaja/recordFlujoCaja.js": 396,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 397,
	"./cash/flujocaja/tableFlujoCaja.js": 397,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 398,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 398,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 399,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 399,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1015,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1015,
	"./cash/pagopremio/PagoPremio": 400,
	"./cash/pagopremio/PagoPremio.js": 400,
	"./cash/pagopremio/detailsPagoPremio": 401,
	"./cash/pagopremio/detailsPagoPremio.js": 401,
	"./cash/pagopremio/filterPagoPremio": 402,
	"./cash/pagopremio/filterPagoPremio.js": 402,
	"./cash/pagopremio/recordPagoPremio": 403,
	"./cash/pagopremio/recordPagoPremio.js": 403,
	"./cash/pagopremio/recordTablePagoPremio": 1360,
	"./cash/pagopremio/recordTablePagoPremio.js": 1360,
	"./cash/pagopremio/tablePagoPremio": 404,
	"./cash/pagopremio/tablePagoPremio.js": 404,
	"./cash/pagopremiovirtuales/PagoPremio": 405,
	"./cash/pagopremiovirtuales/PagoPremio.js": 405,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 406,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 406,
	"./cash/pagopremiovirtuales/filterPagoPremio": 407,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 407,
	"./cash/pagopremiovirtuales/recordPagoPremio": 408,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 408,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1361,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1361,
	"./cash/pagopremiovirtuales/tablePagoPremio": 409,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 409,
	"./cash/payPrizesLoyalty/PagoPremio": 410,
	"./cash/payPrizesLoyalty/PagoPremio.js": 410,
	"./cash/payPrizesLoyalty/filterPagoPremio": 411,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 411,
	"./cash/recargacredito/RecargaCredito": 412,
	"./cash/recargacredito/RecargaCredito.js": 412,
	"./cash/recargacredito/filterRecargaCredito": 413,
	"./cash/recargacredito/filterRecargaCredito.js": 413,
	"./cash/recargacreditoAgent/RecargaCredito": 414,
	"./cash/recargacreditoAgent/RecargaCredito.js": 414,
	"./cash/recargacreditoAgent/filterRecargaCredito": 415,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 415,
	"./cash/withdrawal/filter": 416,
	"./cash/withdrawal/filter.js": 416,
	"./cash/withdrawal/table": 417,
	"./cash/withdrawal/table.js": 417,
	"./cashiers": 1362,
	"./cashiers.js": 1362,
	"./casinoGamesReport": 1363,
	"./casinoGamesReport.js": 1363,
	"./casinoGamesReport2": 1365,
	"./casinoGamesReport2.js": 1365,
	"./categories": 1366,
	"./categories.js": 1366,
	"./categoriesProducts": 1367,
	"./categoriesProducts.js": 1367,
	"./closeBox": 1368,
	"./closeBox-old": 1369,
	"./closeBox-old.js": 1369,
	"./closeBox.js": 1368,
	"./closeBoxEdit": 1370,
	"./closeBoxEdit.js": 1370,
	"./comissionsReport": 1371,
	"./comissionsReport.js": 1371,
	"./comissionsReport2": 1372,
	"./comissionsReport2.js": 1372,
	"./commisionsPay": 1373,
	"./commisionsPay.js": 1373,
	"./competitors/competitors": 1374,
	"./competitors/competitors.js": 1374,
	"./competitors/filter": 434,
	"./competitors/filter.js": 434,
	"./competitors/table": 435,
	"./competitors/table.js": 435,
	"./consolidatedIncome": 1375,
	"./consolidatedIncome.js": 1375,
	"./consolidatedIncomeOwner": 1376,
	"./consolidatedIncomeOwner.js": 1376,
	"./consolidatedIncomeOwner2": 1377,
	"./consolidatedIncomeOwner2.js": 1377,
	"./contingency": 1378,
	"./contingency.js": 1378,
	"./countries": 1379,
	"./countries.js": 1379,
	"./coupons": 1380,
	"./coupons.js": 1380,
	"./couponsReport": 1381,
	"./couponsReport.js": 1381,
	"./cryptoBlockchain": 1382,
	"./cryptoBlockchain.js": 1382,
	"./cryptos": 1383,
	"./cryptos.js": 1383,
	"./customReport": 1384,
	"./customReport.js": 1384,
	"./customers": 1385,
	"./customers.js": 1385,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1386,
	"./customers/bonusReport.js": 1386,
	"./customers/bonusReport2": 1387,
	"./customers/bonusReport2.js": 1387,
	"./customers/casinoGamesReport": 1388,
	"./customers/casinoGamesReport.js": 1388,
	"./customers/configuration": 1389,
	"./customers/configuration.js": 1389,
	"./customers/configuration/changePassword": 1390,
	"./customers/configuration/changePassword.js": 1390,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1391,
	"./customers/configuration/generateToken.js": 1391,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1392,
	"./customers/configuration/limitChanges.js": 1392,
	"./customers/configuration/securityChanges": 1393,
	"./customers/configuration/securityChanges.js": 1393,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1394,
	"./customers/configuration/securityChanges2.js": 1394,
	"./customers/depositReport": 1395,
	"./customers/depositReport.js": 1395,
	"./customers/financescustomer": 1396,
	"./customers/financescustomer.js": 1396,
	"./customers/financial/bankAccounts": 1397,
	"./customers/financial/bankAccounts.js": 1397,
	"./customers/financial/bankAccounts/details": 1020,
	"./customers/financial/bankAccounts/details.js": 1020,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 457,
	"./customers/financial/bankAccounts/record.js": 457,
	"./customers/financial/bankAccounts/recordTable": 1398,
	"./customers/financial/bankAccounts/recordTable.js": 1398,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1399,
	"./customers/financial/bankAccounts/tablePopup.js": 1399,
	"./customers/financial/informationFinancial": 1400,
	"./customers/financial/informationFinancial.js": 1400,
	"./customers/financial/withdrawalRequests": 1401,
	"./customers/financial/withdrawalRequests.js": 1401,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1402,
	"./customers/information.js": 1402,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 458,
	"./customers/paymenthistory.js": 458,
	"./customers/players/filter": 459,
	"./customers/players/filter.js": 459,
	"./customers/players/table": 460,
	"./customers/players/table.js": 460,
	"./customers/players2/filter": 461,
	"./customers/players2/filter.js": 461,
	"./customers/players2/table": 462,
	"./customers/players2/table.js": 462,
	"./customers/playersAggregator/filter": 463,
	"./customers/playersAggregator/filter.js": 463,
	"./customers/playersAggregator/table": 464,
	"./customers/playersAggregator/table.js": 464,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1403,
	"./customers/referralsReport.js": 1403,
	"./customers/reports/autoexclusionUsers": 1404,
	"./customers/reports/autoexclusionUsers.js": 1404,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1405,
	"./customers/reports/balanceAdjustments.js": 1405,
	"./customers/reports/balanceAdjustments/filter": 467,
	"./customers/reports/balanceAdjustments/filter.js": 467,
	"./customers/reports/balanceAdjustments/table": 468,
	"./customers/reports/balanceAdjustments/table.js": 468,
	"./customers/reports/balanceHistory": 1406,
	"./customers/reports/balanceHistory.js": 1406,
	"./customers/reports/balanceHistory/filter": 469,
	"./customers/reports/balanceHistory/filter.js": 469,
	"./customers/reports/balanceHistory/table": 470,
	"./customers/reports/balanceHistory/table.js": 470,
	"./customers/reports/betsReport": 1407,
	"./customers/reports/betsReport.js": 1407,
	"./customers/reports/betsReport/detailsReport": 1408,
	"./customers/reports/betsReport/detailsReport.js": 1408,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 455,
	"./customers/reports/bonusReport2/filterBonusReport.js": 455,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1409,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1409,
	"./customers/reports/bonusReport2/tableBonusReport": 456,
	"./customers/reports/bonusReport2/tableBonusReport.js": 456,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1410,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1410,
	"./customers/reports/casinoReport2/filterCasinoReport": 1411,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1411,
	"./customers/reports/casinoReport2/recordCasinoReport": 1412,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1412,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1413,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1413,
	"./customers/reports/casinoReport2/tableCasinoReport": 1414,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1414,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1415,
	"./customers/reports/historyMovement.js": 1415,
	"./customers/reports/historyMovement/filter": 471,
	"./customers/reports/historyMovement/filter.js": 471,
	"./customers/reports/historyMovement/table": 472,
	"./customers/reports/historyMovement/table.js": 472,
	"./customers/reports/historyPoints": 1416,
	"./customers/reports/historyPoints.js": 1416,
	"./customers/reports/historyPoints/filter": 473,
	"./customers/reports/historyPoints/filter.js": 473,
	"./customers/reports/historyPoints/table": 474,
	"./customers/reports/historyPoints/table.js": 474,
	"./customers/reports/logsUser": 1417,
	"./customers/reports/logsUser.js": 1417,
	"./customers/reports/logsUser/filter": 475,
	"./customers/reports/logsUser/filter.js": 475,
	"./customers/reports/logsUser/table": 476,
	"./customers/reports/logsUser/table.js": 476,
	"./customers/reports/loyaltyLevelChangeHistory": 1021,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1021,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 477,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 477,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 478,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 478,
	"./customers/reports/notesUser": 1418,
	"./customers/reports/notesUser.js": 1418,
	"./customers/reports/notesUser/filter": 479,
	"./customers/reports/notesUser/filter.js": 479,
	"./customers/reports/notesUser/table": 480,
	"./customers/reports/notesUser/table.js": 480,
	"./customers/reports/playerPrizesLoyalty": 1419,
	"./customers/reports/playerPrizesLoyalty.js": 1419,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 481,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 481,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 482,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 482,
	"./customers/reports/playerRoulette": 1420,
	"./customers/reports/playerRoulette.js": 1420,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 483,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 483,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 484,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 484,
	"./customers/reports/qualifyingPointsRecord": 1421,
	"./customers/reports/qualifyingPointsRecord.js": 1421,
	"./customers/reports/qualifyingPointsRecordReport/filter": 485,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 485,
	"./customers/reports/qualifyingPointsRecordReport/table": 486,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 486,
	"./customers/reports/referralsReport/filterReferralsReports": 465,
	"./customers/reports/referralsReport/filterReferralsReports.js": 465,
	"./customers/reports/referralsReport/recordReferralsReports": 1422,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1422,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1423,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1423,
	"./customers/reports/referralsReport/tableReferralsReports": 466,
	"./customers/reports/referralsReport/tableReferralsReports.js": 466,
	"./customers/reports/registeredDocument": 1424,
	"./customers/reports/registeredDocument.js": 1424,
	"./customers/reports/registeredDocuments/filter": 487,
	"./customers/reports/registeredDocuments/filter.js": 487,
	"./customers/reports/registeredDocuments/table": 488,
	"./customers/reports/registeredDocuments/table.js": 488,
	"./customers/reports/sessionsReport": 1425,
	"./customers/reports/sessionsReport.js": 1425,
	"./customers/reports/sessionsReport/detailsSessionsReport": 491,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 491,
	"./customers/reports/sessionsReport/filterSessionsReport": 489,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 489,
	"./customers/reports/sessionsReport/recordSessionsReport": 1022,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1022,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1023,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1023,
	"./customers/reports/sessionsReport/tableSessionsReport": 490,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 490,
	"./customers/reports/sessionsReport2": 1426,
	"./customers/reports/sessionsReport2.js": 1426,
	"./customers/reports/sessionsReport2/filter": 492,
	"./customers/reports/sessionsReport2/filter.js": 492,
	"./customers/reports/sessionsReport2/table": 493,
	"./customers/reports/sessionsReport2/table.js": 493,
	"./customers/reports/walletsReport": 1427,
	"./customers/reports/walletsReport.js": 1427,
	"./customers/reports/walletsReport/filter": 494,
	"./customers/reports/walletsReport/filter.js": 494,
	"./customers/reports/walletsReport/table": 495,
	"./customers/reports/walletsReport/table.js": 495,
	"./customers/reportscustomer": 1428,
	"./customers/reportscustomer.js": 1428,
	"./customers/statistics": 1429,
	"./customers/statistics.js": 1429,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1430,
	"./customersAggregator.js": 1430,
	"./customersAggregator/age": 1431,
	"./customersAggregator/age.js": 1431,
	"./customersAggregator/bonusReport": 1432,
	"./customersAggregator/bonusReport.js": 1432,
	"./customersAggregator/casinoGamesReport": 1433,
	"./customersAggregator/casinoGamesReport.js": 1433,
	"./customersAggregator/configuration": 1434,
	"./customersAggregator/configuration.js": 1434,
	"./customersAggregator/configuration/changePassword": 1435,
	"./customersAggregator/configuration/changePassword.js": 1435,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1436,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1436,
	"./customersAggregator/configuration/generateToken": 1437,
	"./customersAggregator/configuration/generateToken.js": 1437,
	"./customersAggregator/configuration/generateToken/filter": 1438,
	"./customersAggregator/configuration/generateToken/filter.js": 1438,
	"./customersAggregator/configuration/generateToken/table": 1439,
	"./customersAggregator/configuration/generateToken/table.js": 1439,
	"./customersAggregator/configuration/securityChanges": 1440,
	"./customersAggregator/configuration/securityChanges.js": 1440,
	"./customersAggregator/configuration/securityChanges/filter": 1441,
	"./customersAggregator/configuration/securityChanges/filter.js": 1441,
	"./customersAggregator/configuration/securityChanges/table": 1442,
	"./customersAggregator/configuration/securityChanges/table.js": 1442,
	"./customersAggregator/depositReport": 1443,
	"./customersAggregator/depositReport.js": 1443,
	"./customersAggregator/financescustomer": 1444,
	"./customersAggregator/financescustomer.js": 1444,
	"./customersAggregator/financial/bankAccounts": 1445,
	"./customersAggregator/financial/bankAccounts.js": 1445,
	"./customersAggregator/financial/bankAccounts/details": 1446,
	"./customersAggregator/financial/bankAccounts/details.js": 1446,
	"./customersAggregator/financial/bankAccounts/filter": 1447,
	"./customersAggregator/financial/bankAccounts/filter.js": 1447,
	"./customersAggregator/financial/bankAccounts/record": 1448,
	"./customersAggregator/financial/bankAccounts/record.js": 1448,
	"./customersAggregator/financial/bankAccounts/recordTable": 1449,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1449,
	"./customersAggregator/financial/bankAccounts/table": 1450,
	"./customersAggregator/financial/bankAccounts/table.js": 1450,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1451,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1451,
	"./customersAggregator/financial/informationFinancial": 1452,
	"./customersAggregator/financial/informationFinancial.js": 1452,
	"./customersAggregator/financial/withdrawalRequests": 1453,
	"./customersAggregator/financial/withdrawalRequests.js": 1453,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1454,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1454,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1455,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1455,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1456,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1456,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1457,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1457,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1458,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1458,
	"./customersAggregator/geo": 1459,
	"./customersAggregator/geo.js": 1459,
	"./customersAggregator/information": 1460,
	"./customersAggregator/information.js": 1460,
	"./customersAggregator/money": 1461,
	"./customersAggregator/money.js": 1461,
	"./customersAggregator/paymenthistory": 1462,
	"./customersAggregator/paymenthistory.js": 1462,
	"./customersAggregator/players/filter": 1463,
	"./customersAggregator/players/filter.js": 1463,
	"./customersAggregator/players/table": 1464,
	"./customersAggregator/players/table.js": 1464,
	"./customersAggregator/playersAggregator/filter": 1465,
	"./customersAggregator/playersAggregator/filter.js": 1465,
	"./customersAggregator/playersAggregator/table": 1466,
	"./customersAggregator/playersAggregator/table.js": 1466,
	"./customersAggregator/positions": 1467,
	"./customersAggregator/positions.js": 1467,
	"./customersAggregator/reports/autoexclusionUsers": 1468,
	"./customersAggregator/reports/autoexclusionUsers.js": 1468,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1469,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1469,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1470,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1470,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1471,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1471,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1472,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1472,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1473,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1473,
	"./customersAggregator/reports/betsReport": 1474,
	"./customersAggregator/reports/betsReport.js": 1474,
	"./customersAggregator/reports/betsReport/detailsReport": 1475,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1475,
	"./customersAggregator/reports/betsReport/filterReport": 1476,
	"./customersAggregator/reports/betsReport/filterReport.js": 1476,
	"./customersAggregator/reports/betsReport/recordReport": 1477,
	"./customersAggregator/reports/betsReport/recordReport.js": 1477,
	"./customersAggregator/reports/betsReport/recordTableReport": 1478,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1478,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1479,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1479,
	"./customersAggregator/reports/betsReport/recordTransReport": 1480,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1480,
	"./customersAggregator/reports/betsReport/tableReport": 1481,
	"./customersAggregator/reports/betsReport/tableReport.js": 1481,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1482,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1482,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1483,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1483,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1484,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1484,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1485,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1485,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1486,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1486,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1487,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1487,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1488,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1488,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1489,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1489,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1490,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1490,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1491,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1491,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1492,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1492,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1493,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1493,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1494,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1494,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1495,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1495,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1496,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1496,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1497,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1497,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1498,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1498,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1499,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1499,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1500,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1500,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1501,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1501,
	"./customersAggregator/reportscustomer": 1502,
	"./customersAggregator/reportscustomer.js": 1502,
	"./customersAggregator/statistics": 1503,
	"./customersAggregator/statistics.js": 1503,
	"./customersAggregator/tags": 1504,
	"./customersAggregator/tags.js": 1504,
	"./dashboard": 1505,
	"./dashboard.js": 1505,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 496,
	"./dates.js": 496,
	"./demos": 1506,
	"./demos.js": 1506,
	"./depositReport": 1507,
	"./depositReport.js": 1507,
	"./depositReport2": 1508,
	"./depositReport2.js": 1508,
	"./depositReport3": 1509,
	"./depositReport3.js": 1509,
	"./depositReportBetShop": 1510,
	"./depositReportBetShop.js": 1510,
	"./depositRequests": 1511,
	"./depositRequests.js": 1511,
	"./eliminateNoteWithdraw": 1512,
	"./eliminateNoteWithdraw.js": 1512,
	"./emailsReport": 1513,
	"./emailsReport.js": 1513,
	"./financial/depositRequests/filter": 505,
	"./financial/depositRequests/filter.js": 505,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 507,
	"./financial/depositRequests/recordTable.js": 507,
	"./financial/depositRequests/table": 506,
	"./financial/depositRequests/table.js": 506,
	"./financial/withdrawalRequests": 1514,
	"./financial/withdrawalRequests.js": 1514,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 514,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 514,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1515,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1515,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 515,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 515,
	"./flujoCaja": 1516,
	"./flujoCaja.js": 1516,
	"./franchisee": 1517,
	"./franchisee.js": 1517,
	"./franchises": 1518,
	"./franchises.js": 1518,
	"./futureEvents": 1519,
	"./futureEvents.js": 1519,
	"./gamePerformanceReport": 1520,
	"./gamePerformanceReport.js": 1520,
	"./getReportStructureGames": 1521,
	"./getReportStructureGames.js": 1521,
	"./goldenRace": 1522,
	"./goldenRace.js": 1522,
	"./historicalCashFlow": 1523,
	"./historicalCashFlow.js": 1523,
	"./historyMovement": 1524,
	"./historyMovement.js": 1524,
	"./historyMovement/filter": 1525,
	"./historyMovement/filter.js": 1525,
	"./historyMovement/table": 1526,
	"./historyMovement/table.js": 1526,
	"./historyMovementBetShop": 1527,
	"./historyMovementBetShop.js": 1527,
	"./historyPoints": 1528,
	"./historyPoints.js": 1528,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1529,
	"./information/recordTable.js": 1529,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1530,
	"./informationCasino.js": 1530,
	"./informationHipica": 1531,
	"./informationHipica.js": 1531,
	"./informationLiveCasino": 1532,
	"./informationLiveCasino.js": 1532,
	"./informationVirtual": 1533,
	"./informationVirtual.js": 1533,
	"./informeCasino": 1534,
	"./informeCasino.js": 1534,
	"./informeGerencial": 1535,
	"./informeGerencial.js": 1535,
	"./informeGerencial2": 1536,
	"./informeGerencial2.js": 1536,
	"./informeGerencialAgentes2": 1537,
	"./informeGerencialAgentes2.js": 1537,
	"./informeGerencialUsuarios2": 1538,
	"./informeGerencialUsuarios2.js": 1538,
	"./jackpotInternationalReport2": 1539,
	"./jackpotInternationalReport2.js": 1539,
	"./jackpotPaymentReports": 1540,
	"./jackpotPaymentReports.js": 1540,
	"./jackpotPaymentReports2": 1541,
	"./jackpotPaymentReports2.js": 1541,
	"./jackpotPrizeReport": 1542,
	"./jackpotPrizeReport.js": 1542,
	"./jackpotPrizeReportSportBet": 1543,
	"./jackpotPrizeReportSportBet.js": 1543,
	"./jackpotWinnersReport": 1544,
	"./jackpotWinnersReport.js": 1544,
	"./landingReport": 1545,
	"./landingReport.js": 1545,
	"./landingReport2": 1546,
	"./landingReport2.js": 1546,
	"./leagues/AddLeague": 1547,
	"./leagues/AddLeague.js": 1547,
	"./leagues/addLeagueManagement": 1548,
	"./leagues/addLeagueManagement.js": 1548,
	"./leagues/configuration": 1549,
	"./leagues/configuration.js": 1549,
	"./leagues/configuration/changePassword": 1550,
	"./leagues/configuration/changePassword.js": 1550,
	"./leagues/configuration/changePassword/changePasswordView": 1551,
	"./leagues/configuration/changePassword/changePasswordView.js": 1551,
	"./leagues/configuration/generateToken": 1552,
	"./leagues/configuration/generateToken.js": 1552,
	"./leagues/configuration/generateToken/filter": 1553,
	"./leagues/configuration/generateToken/filter.js": 1553,
	"./leagues/configuration/generateToken/table": 1554,
	"./leagues/configuration/generateToken/table.js": 1554,
	"./leagues/configuration/qrgoogle": 1555,
	"./leagues/configuration/qrgoogle.js": 1555,
	"./leagues/configuration/securityChanges": 1556,
	"./leagues/configuration/securityChanges.js": 1556,
	"./leagues/configuration/securityChanges/filter": 1557,
	"./leagues/configuration/securityChanges/filter.js": 1557,
	"./leagues/configuration/securityChanges/table": 1558,
	"./leagues/configuration/securityChanges/table.js": 1558,
	"./leagues/information": 1559,
	"./leagues/information.js": 1559,
	"./leagues/leagues-list/filter": 567,
	"./leagues/leagues-list/filter.js": 567,
	"./leagues/leagues-list/table": 568,
	"./leagues/leagues-list/table.js": 568,
	"./leagues/leaguesList": 1560,
	"./leagues/leaguesList.js": 1560,
	"./leagues/leaguesManagement": 1561,
	"./leagues/leaguesManagement.js": 1561,
	"./leagues/reports": 1562,
	"./leagues/reports.js": 1562,
	"./leagues/reports/betsReport": 1563,
	"./leagues/reports/betsReport.js": 1563,
	"./leagues/reports/betsReport/detailsReport": 1564,
	"./leagues/reports/betsReport/detailsReport.js": 1564,
	"./leagues/reports/betsReport/filterReport": 570,
	"./leagues/reports/betsReport/filterReport.js": 570,
	"./leagues/reports/betsReport/recordReport": 1565,
	"./leagues/reports/betsReport/recordReport.js": 1565,
	"./leagues/reports/betsReport/recordTableReport": 1566,
	"./leagues/reports/betsReport/recordTableReport.js": 1566,
	"./leagues/reports/betsReport/recordTableTransReport": 1567,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1567,
	"./leagues/reports/betsReport/recordTransReport": 572,
	"./leagues/reports/betsReport/recordTransReport.js": 572,
	"./leagues/reports/betsReport/tableReport": 571,
	"./leagues/reports/betsReport/tableReport.js": 571,
	"./leagues/reports/casinoGamesReport": 1568,
	"./leagues/reports/casinoGamesReport.js": 1568,
	"./leagues/reports/casinoReport/detailsCasinoReport": 575,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 575,
	"./leagues/reports/casinoReport/filterCasinoReport": 573,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 573,
	"./leagues/reports/casinoReport/recordCasinoReport": 576,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 576,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1569,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1569,
	"./leagues/reports/casinoReport/tableCasinoReport": 574,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 574,
	"./leagues/reports/userAfilliatesReport": 1570,
	"./leagues/reports/userAfilliatesReport.js": 1570,
	"./leagues/reports/user_affiliates/detailsReports": 1571,
	"./leagues/reports/user_affiliates/detailsReports.js": 1571,
	"./leagues/reports/user_affiliates/filterReports": 577,
	"./leagues/reports/user_affiliates/filterReports.js": 577,
	"./leagues/reports/user_affiliates/recordReports": 1572,
	"./leagues/reports/user_affiliates/recordReports.js": 1572,
	"./leagues/reports/user_affiliates/recordTableReports": 1573,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1573,
	"./leagues/reports/user_affiliates/tableReports": 578,
	"./leagues/reports/user_affiliates/tableReports.js": 578,
	"./leagues/results/recordTableResponts": 569,
	"./leagues/results/recordTableResponts.js": 569,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1574,
	"./leagues/statistics.js": 1574,
	"./leagues/statistics/age": 582,
	"./leagues/statistics/age.js": 582,
	"./leagues/statistics/marketing": 580,
	"./leagues/statistics/marketing.js": 580,
	"./leagues/statistics/marketingvsregistros": 581,
	"./leagues/statistics/marketingvsregistros.js": 581,
	"./leagues/statistics/money": 579,
	"./leagues/statistics/money.js": 579,
	"./limitationsReport": 1575,
	"./limitationsReport.js": 1575,
	"./loading": 1576,
	"./loading.js": 1576,
	"./login": 1577,
	"./login.js": 1577,
	"./logsUserGeneral": 1578,
	"./logsUserGeneral.js": 1578,
	"./loteryReport": 1579,
	"./loteryReport.js": 1579,
	"./loyaltyLevelChangeHistory": 1580,
	"./loyaltyLevelChangeHistory.js": 1580,
	"./machine/AddMachineRegister": 1581,
	"./machine/AddMachineRegister.js": 1581,
	"./machine/addMachineManagement": 1582,
	"./machine/addMachineManagement.js": 1582,
	"./machine/cashier/advertising": 592,
	"./machine/cashier/advertising.js": 592,
	"./machine/cashier/cashier": 1583,
	"./machine/cashier/cashier.js": 1583,
	"./machine/cashier/tableAdvertising": 593,
	"./machine/cashier/tableAdvertising.js": 593,
	"./machine/configuration": 1584,
	"./machine/configuration.js": 1584,
	"./machine/configuration/changePassword": 1585,
	"./machine/configuration/changePassword.js": 1585,
	"./machine/configuration/changePassword/changePasswordView": 1586,
	"./machine/configuration/changePassword/changePasswordView.js": 1586,
	"./machine/configuration/generateToken": 1587,
	"./machine/configuration/generateToken.js": 1587,
	"./machine/configuration/generateToken/filter": 1588,
	"./machine/configuration/generateToken/filter.js": 1588,
	"./machine/configuration/generateToken/table": 1589,
	"./machine/configuration/generateToken/table.js": 1589,
	"./machine/configuration/qrgoogle": 1590,
	"./machine/configuration/qrgoogle.js": 1590,
	"./machine/configuration/securityChanges": 1591,
	"./machine/configuration/securityChanges.js": 1591,
	"./machine/configuration/securityChanges/filter": 1027,
	"./machine/configuration/securityChanges/filter.js": 1027,
	"./machine/configuration/securityChanges/table": 594,
	"./machine/configuration/securityChanges/table.js": 594,
	"./machine/filter": 595,
	"./machine/filter.js": 595,
	"./machine/information": 1592,
	"./machine/information.js": 1592,
	"./machine/machineManagement": 1593,
	"./machine/machineManagement.js": 1593,
	"./machine/machineRegister": 1594,
	"./machine/machineRegister.js": 1594,
	"./machine/managePointsGraphics": 1595,
	"./machine/managePointsGraphics.js": 1595,
	"./machine/pagoNotaCobro": 1596,
	"./machine/pagoNotaCobro.js": 1596,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1028,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1028,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 599,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 599,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 600,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 600,
	"./machine/pagoPremioMaquina": 1597,
	"./machine/pagoPremioMaquina.js": 1597,
	"./machine/pagopremio/PagoPremio": 602,
	"./machine/pagopremio/PagoPremio.js": 602,
	"./machine/pagopremio/detailsPagoPremio": 604,
	"./machine/pagopremio/detailsPagoPremio.js": 604,
	"./machine/pagopremio/filterPagoPremio": 601,
	"./machine/pagopremio/filterPagoPremio.js": 601,
	"./machine/pagopremio/recordPagoPremio": 605,
	"./machine/pagopremio/recordPagoPremio.js": 605,
	"./machine/pagopremio/recordTablePagoPremio": 1598,
	"./machine/pagopremio/recordTablePagoPremio.js": 1598,
	"./machine/pagopremio/tablePagoPremio": 603,
	"./machine/pagopremio/tablePagoPremio.js": 603,
	"./machine/pointsGraphics/filter": 597,
	"./machine/pointsGraphics/filter.js": 597,
	"./machine/pointsGraphics/pointsList": 598,
	"./machine/pointsGraphics/pointsList.js": 598,
	"./machine/products2": 1599,
	"./machine/products2.js": 1599,
	"./machine/products2/categories-products/filter": 606,
	"./machine/products2/categories-products/filter.js": 606,
	"./machine/products2/categories-products/table": 607,
	"./machine/products2/categories-products/table.js": 607,
	"./machine/products2/categoriesProducts": 1600,
	"./machine/products2/categoriesProducts.js": 1600,
	"./machine/products2/partners-games/filter": 608,
	"./machine/products2/partners-games/filter.js": 608,
	"./machine/products2/partners-games/table": 609,
	"./machine/products2/partners-games/table.js": 609,
	"./machine/products2/partners-products/filter": 610,
	"./machine/products2/partners-products/filter.js": 610,
	"./machine/products2/partners-products/table": 611,
	"./machine/products2/partners-products/table.js": 611,
	"./machine/products2/partners-providers/filter": 612,
	"./machine/products2/partners-providers/filter.js": 612,
	"./machine/products2/partners-providers/table": 613,
	"./machine/products2/partners-providers/table.js": 613,
	"./machine/products2/partners-subProviders/filter": 614,
	"./machine/products2/partners-subProviders/filter.js": 614,
	"./machine/products2/partners-subProviders/table": 615,
	"./machine/products2/partners-subProviders/table.js": 615,
	"./machine/products2/partners-tipoproducto/filter": 616,
	"./machine/products2/partners-tipoproducto/filter.js": 616,
	"./machine/products2/partners-tipoproducto/table": 617,
	"./machine/products2/partners-tipoproducto/table.js": 617,
	"./machine/products2/partnersGames": 1601,
	"./machine/products2/partnersGames.js": 1601,
	"./machine/products2/partnersProducts": 1602,
	"./machine/products2/partnersProducts.js": 1602,
	"./machine/products2/partnersProviders": 1603,
	"./machine/products2/partnersProviders.js": 1603,
	"./machine/products2/partnersSubProviders": 1604,
	"./machine/products2/partnersSubProviders.js": 1604,
	"./machine/products2/partnersTypeProduct": 1605,
	"./machine/products2/partnersTypeProduct.js": 1605,
	"./machine/reports": 1606,
	"./machine/reports.js": 1606,
	"./machine/reports/betsReport": 1607,
	"./machine/reports/betsReport.js": 1607,
	"./machine/reports/betsReport/detailsReport": 1608,
	"./machine/reports/betsReport/detailsReport.js": 1608,
	"./machine/reports/betsReport/filterReport": 618,
	"./machine/reports/betsReport/filterReport.js": 618,
	"./machine/reports/betsReport/recordReport": 1609,
	"./machine/reports/betsReport/recordReport.js": 1609,
	"./machine/reports/betsReport/recordTableReport": 1610,
	"./machine/reports/betsReport/recordTableReport.js": 1610,
	"./machine/reports/betsReport/recordTableTransReport": 1611,
	"./machine/reports/betsReport/recordTableTransReport.js": 1611,
	"./machine/reports/betsReport/recordTransReport": 620,
	"./machine/reports/betsReport/recordTransReport.js": 620,
	"./machine/reports/betsReport/tableReport": 619,
	"./machine/reports/betsReport/tableReport.js": 619,
	"./machine/reports/casinoGamesReport": 1612,
	"./machine/reports/casinoGamesReport.js": 1612,
	"./machine/reports/casinoReport/detailsCasinoReport": 623,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 623,
	"./machine/reports/casinoReport/filterCasinoReport": 621,
	"./machine/reports/casinoReport/filterCasinoReport.js": 621,
	"./machine/reports/casinoReport/recordCasinoReport": 624,
	"./machine/reports/casinoReport/recordCasinoReport.js": 624,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1613,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1613,
	"./machine/reports/casinoReport/tableCasinoReport": 622,
	"./machine/reports/casinoReport/tableCasinoReport.js": 622,
	"./machine/reports/depositReport": 1614,
	"./machine/reports/depositReport.js": 1614,
	"./machine/reports/deposit_report/detailsDepositReports": 1029,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1029,
	"./machine/reports/deposit_report/filterDepositReports": 625,
	"./machine/reports/deposit_report/filterDepositReports.js": 625,
	"./machine/reports/deposit_report/recordDepositReports": 627,
	"./machine/reports/deposit_report/recordDepositReports.js": 627,
	"./machine/reports/deposit_report/recordTableDepositReports": 1615,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1615,
	"./machine/reports/deposit_report/tableDepositReports": 626,
	"./machine/reports/deposit_report/tableDepositReports.js": 626,
	"./machine/reports/flujoCaja": 1616,
	"./machine/reports/flujoCaja.js": 1616,
	"./machine/reports/flujocaja/detailsFlujoCaja": 630,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 630,
	"./machine/reports/flujocaja/filterFlujoCaja": 628,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 628,
	"./machine/reports/flujocaja/recordFlujoCaja": 631,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 631,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1617,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1617,
	"./machine/reports/flujocaja/tableFlujoCaja": 629,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 629,
	"./machine/reports/log/log": 632,
	"./machine/reports/log/log.js": 632,
	"./machine/reports/logReport": 1618,
	"./machine/reports/logReport.js": 1618,
	"./machine/reports/updates/filter": 633,
	"./machine/reports/updates/filter.js": 633,
	"./machine/reports/updates/table": 634,
	"./machine/reports/updates/table.js": 634,
	"./machine/reports/updatesReport": 1619,
	"./machine/reports/updatesReport.js": 1619,
	"./machine/reports/userAfilliatesReport": 1620,
	"./machine/reports/userAfilliatesReport.js": 1620,
	"./machine/reports/user_affiliates/detailsReports": 1621,
	"./machine/reports/user_affiliates/detailsReports.js": 1621,
	"./machine/reports/user_affiliates/filterReports": 635,
	"./machine/reports/user_affiliates/filterReports.js": 635,
	"./machine/reports/user_affiliates/recordReports": 1622,
	"./machine/reports/user_affiliates/recordReports.js": 1622,
	"./machine/reports/user_affiliates/recordTableReports": 1623,
	"./machine/reports/user_affiliates/recordTableReports.js": 1623,
	"./machine/reports/user_affiliates/tableReports": 636,
	"./machine/reports/user_affiliates/tableReports.js": 636,
	"./machine/reports/withdrawalRequests": 1624,
	"./machine/reports/withdrawalRequests.js": 1624,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 639,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 639,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 637,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 637,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1625,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1625,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 640,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 640,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 638,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 638,
	"./machine/results/recordTableResponts": 1626,
	"./machine/results/recordTableResponts.js": 1626,
	"./machine/results/tableResults": 1627,
	"./machine/results/tableResults.js": 1627,
	"./machine/statistics": 1628,
	"./machine/statistics.js": 1628,
	"./machine/statistics/age": 644,
	"./machine/statistics/age.js": 644,
	"./machine/statistics/marketing": 642,
	"./machine/statistics/marketing.js": 642,
	"./machine/statistics/marketingvsregistros": 643,
	"./machine/statistics/marketingvsregistros.js": 643,
	"./machine/statistics/money": 641,
	"./machine/statistics/money.js": 641,
	"./machine/table": 596,
	"./machine/table.js": 596,
	"./management/activateRegistration/filter": 203,
	"./management/activateRegistration/filter.js": 203,
	"./management/activateRegistration/response": 204,
	"./management/activateRegistration/response.js": 204,
	"./management/coupons/coupons": 446,
	"./management/coupons/coupons.js": 446,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 509,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 509,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 508,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 508,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 511,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 511,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 510,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 510,
	"./management/faltan.txt": 1958,
	"./management/managementClaims/filter": 645,
	"./management/managementClaims/filter.js": 645,
	"./management/managementClaims/table": 646,
	"./management/managementClaims/table.js": 646,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 647,
	"./management/managementContact/detailsTable.js": 647,
	"./management/managementContact/filterManagementContact": 648,
	"./management/managementContact/filterManagementContact.js": 648,
	"./management/managementContact/tableManagementContact": 649,
	"./management/managementContact/tableManagementContact.js": 649,
	"./management/managementContactUser/filter": 650,
	"./management/managementContactUser/filter.js": 650,
	"./management/managementContactUser/table": 651,
	"./management/managementContactUser/table.js": 651,
	"./management/managementGenericForms/filter": 652,
	"./management/managementGenericForms/filter.js": 652,
	"./management/managementGenericForms/table": 653,
	"./management/managementGenericForms/table.js": 653,
	"./management/quotaRetraction/Retraction": 654,
	"./management/quotaRetraction/Retraction.js": 654,
	"./management/quotaRetraction/search": 1030,
	"./management/quotaRetraction/search.js": 1030,
	"./management/registerFast/filterRegisterFast": 655,
	"./management/registerFast/filterRegisterFast.js": 655,
	"./management/registerFast/tableRegisterFast": 656,
	"./management/registerFast/tableRegisterFast.js": 656,
	"./management/reprintCheck/filterReprintCheck": 657,
	"./management/reprintCheck/filterReprintCheck.js": 657,
	"./management/reprintCheck/tableReprintCheck": 658,
	"./management/reprintCheck/tableReprintCheck.js": 658,
	"./management/restrictUser/filter": 659,
	"./management/restrictUser/filter.js": 659,
	"./management/restrictUser/table": 660,
	"./management/restrictUser/table.js": 660,
	"./management/reversionReload/filterReversionReload": 661,
	"./management/reversionReload/filterReversionReload.js": 661,
	"./management/reversionReload/tableReversionReload": 662,
	"./management/reversionReload/tableReversionReload.js": 662,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 663,
	"./management/usersVerification/informationJumio.js": 663,
	"./managementClaims": 1629,
	"./managementClaims.js": 1629,
	"./managementContact": 1630,
	"./managementContact.js": 1630,
	"./managementContactUser": 1631,
	"./managementContactUser.js": 1631,
	"./managementGenericForms": 1632,
	"./managementGenericForms.js": 1632,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1633,
	"./menuBonus.js": 1633,
	"./menuBuilder": 1634,
	"./menuBuilder.js": 1634,
	"./menuMarketing": 1635,
	"./menuMarketing.js": 1635,
	"./menus": 1636,
	"./menus.js": 1636,
	"./messages/bannerInvasive": 1637,
	"./messages/bannerInvasive.js": 1637,
	"./messages/bannerInvasive/filter": 666,
	"./messages/bannerInvasive/filter.js": 666,
	"./messages/bannerInvasive/table": 667,
	"./messages/bannerInvasive/table.js": 667,
	"./messages/fringe": 1638,
	"./messages/fringe.js": 1638,
	"./messages/fringe/filter": 668,
	"./messages/fringe/filter.js": 668,
	"./messages/fringe/table": 669,
	"./messages/fringe/table.js": 669,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 670,
	"./messages/messageInternAgent/filter.js": 670,
	"./messages/messageInternAgent/table": 671,
	"./messages/messageInternAgent/table.js": 671,
	"./messages/messageInternal": 1639,
	"./messages/messageInternal.js": 1639,
	"./messages/messageInternalAgent": 1640,
	"./messages/messageInternalAgent.js": 1640,
	"./messages/messageList": 1641,
	"./messages/messageList.js": 1641,
	"./messages/popup": 1642,
	"./messages/popup.js": 1642,
	"./messages/popup/filter": 672,
	"./messages/popup/filter.js": 672,
	"./messages/popup/table": 673,
	"./messages/popup/table.js": 673,
	"./messagesOld/messageIntern/filter": 1643,
	"./messagesOld/messageIntern/filter.js": 1643,
	"./messagesOld/messageIntern/table": 1644,
	"./messagesOld/messageIntern/table.js": 1644,
	"./messagesOld/messageList": 1645,
	"./messagesOld/messageList.js": 1645,
	"./myComissionsReport": 1646,
	"./myComissionsReport.js": 1646,
	"./myConfiguration/changeMyPassword": 1647,
	"./myConfiguration/changeMyPassword.js": 1647,
	"./myConfiguration/myInfoBetShop": 1648,
	"./myConfiguration/myInfoBetShop.js": 1648,
	"./myConfiguration/myInfoCustomer": 1649,
	"./myConfiguration/myInfoCustomer.js": 1649,
	"./myConfiguration/myInformation": 1650,
	"./myConfiguration/myInformation.js": 1650,
	"./myConfiguration/qrgoogle": 1651,
	"./myConfiguration/qrgoogle.js": 1651,
	"./notesUser": 1652,
	"./notesUser.js": 1652,
	"./notifications": 1001,
	"./notifications.js": 1001,
	"./operatorResponsibility": 1653,
	"./operatorResponsibility.js": 1653,
	"./ownersIncome": 1654,
	"./ownersIncome.js": 1654,
	"./ownersIncomeSecondLevel": 1655,
	"./ownersIncomeSecondLevel.js": 1655,
	"./pagoNotaRetiro": 1656,
	"./pagoNotaRetiro.js": 1656,
	"./pagoPremio": 1657,
	"./pagoPremio.js": 1657,
	"./pagoPremioVirtuales": 1658,
	"./pagoPremioVirtuales.js": 1658,
	"./paidPendingAwards": 1659,
	"./paidPendingAwards.js": 1659,
	"./partner/PartnerSettings": 1660,
	"./partner/PartnerSettings.js": 1660,
	"./partner/PartnerSettingsOld": 1661,
	"./partner/PartnerSettingsOld.js": 1661,
	"./partner/TRM": 1662,
	"./partner/TRM.js": 1662,
	"./partner/TRM/filter": 688,
	"./partner/TRM/filter.js": 688,
	"./partner/TRM/table": 689,
	"./partner/TRM/table.js": 689,
	"./partner/configuration": 1663,
	"./partner/configuration.js": 1663,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1664,
	"./partner/configurationControl.js": 1664,
	"./partner/configurationControl/filter": 690,
	"./partner/configurationControl/filter.js": 690,
	"./partner/configurationControl/table": 691,
	"./partner/configurationControl/table.js": 691,
	"./partner/configurationControl2": 1665,
	"./partner/configurationControl2.js": 1665,
	"./partner/configurationControl2/filter": 692,
	"./partner/configurationControl2/filter.js": 692,
	"./partner/configurationControl2/table": 693,
	"./partner/configurationControl2/table.js": 693,
	"./partner/configurationOld/filter": 1666,
	"./partner/configurationOld/filter.js": 1666,
	"./partner/configurationOld/settings": 1667,
	"./partner/configurationOld/settings.js": 1667,
	"./partner/configurationSEO": 1668,
	"./partner/configurationSEO.js": 1668,
	"./partner/configurationSEO/filter": 694,
	"./partner/configurationSEO/filter.js": 694,
	"./partner/configurationSEO/settings": 695,
	"./partner/configurationSEO/settings.js": 695,
	"./partner/countries": 1669,
	"./partner/countries.js": 1669,
	"./partner/countries/countries": 696,
	"./partner/countries/countries.js": 696,
	"./partner/menusUser": 1670,
	"./partner/menusUser.js": 1670,
	"./partner/menusUser/filter": 697,
	"./partner/menusUser/filter.js": 697,
	"./partner/menusUser/table": 698,
	"./partner/menusUser/table.js": 698,
	"./partner/partner-list/filter": 686,
	"./partner/partner-list/filter.js": 686,
	"./partner/partner-list/table": 687,
	"./partner/partner-list/table.js": 687,
	"./partner/partnertManagement": 1671,
	"./partner/partnertManagement.js": 1671,
	"./partner/products": 1672,
	"./partner/products.js": 1672,
	"./partner/products/categories-products/filter": 699,
	"./partner/products/categories-products/filter.js": 699,
	"./partner/products/categories-products/table": 700,
	"./partner/products/categories-products/table.js": 700,
	"./partner/products/categoriesProducts": 1673,
	"./partner/products/categoriesProducts.js": 1673,
	"./partner/products/partners-products/filter": 701,
	"./partner/products/partners-products/filter.js": 701,
	"./partner/products/partners-products/table": 702,
	"./partner/products/partners-products/table.js": 702,
	"./partner/products/partners-providers/filter": 703,
	"./partner/products/partners-providers/filter.js": 703,
	"./partner/products/partners-providers/table": 704,
	"./partner/products/partners-providers/table.js": 704,
	"./partner/products/partners-subProviders/filter": 705,
	"./partner/products/partners-subProviders/filter.js": 705,
	"./partner/products/partners-subProviders/table": 706,
	"./partner/products/partners-subProviders/table.js": 706,
	"./partner/products/partners-tipoproducto/filter": 707,
	"./partner/products/partners-tipoproducto/filter.js": 707,
	"./partner/products/partners-tipoproducto/table": 708,
	"./partner/products/partners-tipoproducto/table.js": 708,
	"./partner/products/partnersProducts": 1674,
	"./partner/products/partnersProducts.js": 1674,
	"./partner/products/partnersProviders": 1675,
	"./partner/products/partnersProviders.js": 1675,
	"./partner/products/partnersSubProviders": 1676,
	"./partner/products/partnersSubProviders.js": 1676,
	"./partner/products/partnersTypeProduct": 1677,
	"./partner/products/partnersTypeProduct.js": 1677,
	"./partner/products/products-banks/filter": 709,
	"./partner/products/products-banks/filter.js": 709,
	"./partner/products/products-banks/table": 710,
	"./partner/products/products-banks/table.js": 710,
	"./partner/products/products-cryptoNetwork/filter": 711,
	"./partner/products/products-cryptoNetwork/filter.js": 711,
	"./partner/products/products-cryptoNetwork/table": 712,
	"./partner/products/products-cryptoNetwork/table.js": 712,
	"./partner/products/products-franchises/filter": 713,
	"./partner/products/products-franchises/filter.js": 713,
	"./partner/products/products-franchises/table": 714,
	"./partner/products/products-franchises/table.js": 714,
	"./partner/products/productsBanks": 1678,
	"./partner/products/productsBanks.js": 1678,
	"./partner/products/productsCryptoNetwork": 1679,
	"./partner/products/productsCryptoNetwork.js": 1679,
	"./partner/products/productsFranchises": 1680,
	"./partner/products/productsFranchises.js": 1680,
	"./partner/products2": 1681,
	"./partner/products2.js": 1681,
	"./partner/products2/banks-partners/filter": 715,
	"./partner/products2/banks-partners/filter.js": 715,
	"./partner/products2/banks-partners/table": 716,
	"./partner/products2/banks-partners/table.js": 716,
	"./partner/products2/categories-products/filter": 717,
	"./partner/products2/categories-products/filter.js": 717,
	"./partner/products2/categories-products/table": 718,
	"./partner/products2/categories-products/table.js": 718,
	"./partner/products2/categoriesProducts": 1682,
	"./partner/products2/categoriesProducts.js": 1682,
	"./partner/products2/enablement-products/filter": 719,
	"./partner/products2/enablement-products/filter.js": 719,
	"./partner/products2/enablement-products/table": 720,
	"./partner/products2/enablement-products/table.js": 720,
	"./partner/products2/enablementProducts": 1683,
	"./partner/products2/enablementProducts.js": 1683,
	"./partner/products2/franchises-partner/filter": 721,
	"./partner/products2/franchises-partner/filter.js": 721,
	"./partner/products2/franchises-partner/table": 722,
	"./partner/products2/franchises-partner/table.js": 722,
	"./partner/products2/partners-categories/filter": 723,
	"./partner/products2/partners-categories/filter.js": 723,
	"./partner/products2/partners-categories/table": 724,
	"./partner/products2/partners-categories/table.js": 724,
	"./partner/products2/partners-credentialsSubProviders/filter": 725,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 725,
	"./partner/products2/partners-credentialsSubProviders/table": 726,
	"./partner/products2/partners-credentialsSubProviders/table.js": 726,
	"./partner/products2/partners-games/filter": 727,
	"./partner/products2/partners-games/filter.js": 727,
	"./partner/products2/partners-games/table": 728,
	"./partner/products2/partners-games/table.js": 728,
	"./partner/products2/partners-products/filter": 729,
	"./partner/products2/partners-products/filter.js": 729,
	"./partner/products2/partners-products/table": 730,
	"./partner/products2/partners-products/table.js": 730,
	"./partner/products2/partners-providers-order/filter": 1684,
	"./partner/products2/partners-providers-order/filter.js": 1684,
	"./partner/products2/partners-providers-order/table": 1685,
	"./partner/products2/partners-providers-order/table.js": 1685,
	"./partner/products2/partners-providers/filter": 731,
	"./partner/products2/partners-providers/filter.js": 731,
	"./partner/products2/partners-providers/table": 732,
	"./partner/products2/partners-providers/table.js": 732,
	"./partner/products2/partners-subProviders-order/filter": 733,
	"./partner/products2/partners-subProviders-order/filter.js": 733,
	"./partner/products2/partners-subProviders-order/table": 734,
	"./partner/products2/partners-subProviders-order/table.js": 734,
	"./partner/products2/partners-subProviders/filter": 735,
	"./partner/products2/partners-subProviders/filter.js": 735,
	"./partner/products2/partners-subProviders/table": 736,
	"./partner/products2/partners-subProviders/table.js": 736,
	"./partner/products2/partners-tipoproducto/filter": 737,
	"./partner/products2/partners-tipoproducto/filter.js": 737,
	"./partner/products2/partners-tipoproducto/table": 738,
	"./partner/products2/partners-tipoproducto/table.js": 738,
	"./partner/products2/partnersBanks": 1686,
	"./partner/products2/partnersBanks.js": 1686,
	"./partner/products2/partnersCategories": 1687,
	"./partner/products2/partnersCategories.js": 1687,
	"./partner/products2/partnersCredentialsSubProviders": 1688,
	"./partner/products2/partnersCredentialsSubProviders.js": 1688,
	"./partner/products2/partnersFranchises": 1689,
	"./partner/products2/partnersFranchises.js": 1689,
	"./partner/products2/partnersGames": 1690,
	"./partner/products2/partnersGames.js": 1690,
	"./partner/products2/partnersProducts": 1691,
	"./partner/products2/partnersProducts.js": 1691,
	"./partner/products2/partnersProviders": 1692,
	"./partner/products2/partnersProviders.js": 1692,
	"./partner/products2/partnersSubProviders": 1693,
	"./partner/products2/partnersSubProviders.js": 1693,
	"./partner/products2/partnersSubProvidersOrder": 1694,
	"./partner/products2/partnersSubProvidersOrder.js": 1694,
	"./partner/products2/partnersTypeProduct": 1695,
	"./partner/products2/partnersTypeProduct.js": 1695,
	"./partner/reports": 1696,
	"./partner/reports.js": 1696,
	"./partner/reports/autoexclusionUsers": 1697,
	"./partner/reports/autoexclusionUsers.js": 1697,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 741,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 741,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 739,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 739,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1031,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1031,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 742,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 742,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 740,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 740,
	"./partner/reports/balanceAdjustments": 1698,
	"./partner/reports/balanceAdjustments.js": 1698,
	"./partner/reports/balanceAdjustments/filter": 743,
	"./partner/reports/balanceAdjustments/filter.js": 743,
	"./partner/reports/balanceAdjustments/table": 744,
	"./partner/reports/balanceAdjustments/table.js": 744,
	"./partner/reports/balanceHistory": 1699,
	"./partner/reports/balanceHistory.js": 1699,
	"./partner/reports/balanceHistory/filter": 745,
	"./partner/reports/balanceHistory/filter.js": 745,
	"./partner/reports/balanceHistory/table": 746,
	"./partner/reports/balanceHistory/table.js": 746,
	"./partner/reports/balanceHistoryBetShop": 1700,
	"./partner/reports/balanceHistoryBetShop.js": 1700,
	"./partner/reports/balanceHistoryBetShop/filter": 747,
	"./partner/reports/balanceHistoryBetShop/filter.js": 747,
	"./partner/reports/balanceHistoryBetShop/table": 748,
	"./partner/reports/balanceHistoryBetShop/table.js": 748,
	"./partner/reports/balanceUsers": 1701,
	"./partner/reports/balanceUsers.js": 1701,
	"./partner/reports/balanceUsers/filter": 749,
	"./partner/reports/balanceUsers/filter.js": 749,
	"./partner/reports/balanceUsers/record": 751,
	"./partner/reports/balanceUsers/record.js": 751,
	"./partner/reports/balanceUsers/resume": 752,
	"./partner/reports/balanceUsers/resume.js": 752,
	"./partner/reports/balanceUsers/table": 750,
	"./partner/reports/balanceUsers/table.js": 750,
	"./partner/reports/betsReport": 1702,
	"./partner/reports/betsReport.js": 1702,
	"./partner/reports/betsReport/detailsReport": 1703,
	"./partner/reports/betsReport/detailsReport.js": 1703,
	"./partner/reports/betsReport/filterReport": 753,
	"./partner/reports/betsReport/filterReport.js": 753,
	"./partner/reports/betsReport/recordReport": 757,
	"./partner/reports/betsReport/recordReport.js": 757,
	"./partner/reports/betsReport/recordTableReport": 758,
	"./partner/reports/betsReport/recordTableReport.js": 758,
	"./partner/reports/betsReport/recordTableTransReport": 756,
	"./partner/reports/betsReport/recordTableTransReport.js": 756,
	"./partner/reports/betsReport/recordTransReport": 755,
	"./partner/reports/betsReport/recordTransReport.js": 755,
	"./partner/reports/betsReport/tableReport": 754,
	"./partner/reports/betsReport/tableReport.js": 754,
	"./partner/reports/bonusReport": 1704,
	"./partner/reports/bonusReport.js": 1704,
	"./partner/reports/bonusReport/detailsBonusReport": 761,
	"./partner/reports/bonusReport/detailsBonusReport.js": 761,
	"./partner/reports/bonusReport/filterBonusReport": 759,
	"./partner/reports/bonusReport/filterBonusReport.js": 759,
	"./partner/reports/bonusReport/recordBonusReport": 762,
	"./partner/reports/bonusReport/recordBonusReport.js": 762,
	"./partner/reports/bonusReport/recordTableBonusReport": 763,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 763,
	"./partner/reports/bonusReport/tableBonusReport": 760,
	"./partner/reports/bonusReport/tableBonusReport.js": 760,
	"./partner/reports/casinoGamesReport": 1705,
	"./partner/reports/casinoGamesReport.js": 1705,
	"./partner/reports/casinoReport/detailsCasinoReport": 766,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 766,
	"./partner/reports/casinoReport/filterCasinoReport": 764,
	"./partner/reports/casinoReport/filterCasinoReport.js": 764,
	"./partner/reports/casinoReport/recordCasinoReport": 767,
	"./partner/reports/casinoReport/recordCasinoReport.js": 767,
	"./partner/reports/casinoReport/recordTableCasinoReport": 768,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 768,
	"./partner/reports/casinoReport/tableCasinoReport": 765,
	"./partner/reports/casinoReport/tableCasinoReport.js": 765,
	"./partner/reports/comissionsReport": 1706,
	"./partner/reports/comissionsReport.js": 1706,
	"./partner/reports/comissions_report/filter": 769,
	"./partner/reports/comissions_report/filter.js": 769,
	"./partner/reports/comissions_report/table": 770,
	"./partner/reports/comissions_report/table.js": 770,
	"./partner/reports/depositReport": 1707,
	"./partner/reports/depositReport.js": 1707,
	"./partner/reports/deposit_report/detailsDepositReports": 1032,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1032,
	"./partner/reports/deposit_report/filterDepositReports": 771,
	"./partner/reports/deposit_report/filterDepositReports.js": 771,
	"./partner/reports/deposit_report/recordDepositReports": 773,
	"./partner/reports/deposit_report/recordDepositReports.js": 773,
	"./partner/reports/deposit_report/recordTableDepositReports": 774,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 774,
	"./partner/reports/deposit_report/tableDepositReports": 772,
	"./partner/reports/deposit_report/tableDepositReports.js": 772,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 775,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 775,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 776,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 776,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 777,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 777,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 778,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 778,
	"./partner/reports/historicalCashFlow": 1708,
	"./partner/reports/historicalCashFlow.js": 1708,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 781,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 781,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 779,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 779,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 782,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 782,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 783,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 783,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 780,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 780,
	"./partner/reports/historyMovement": 1709,
	"./partner/reports/historyMovement.js": 1709,
	"./partner/reports/historyMovement/filter": 784,
	"./partner/reports/historyMovement/filter.js": 784,
	"./partner/reports/historyMovement/table": 785,
	"./partner/reports/historyMovement/table.js": 785,
	"./partner/reports/informeCasino/detailsInformeCasino": 1710,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1710,
	"./partner/reports/informeCasino/filterInformeCasino": 1711,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1711,
	"./partner/reports/informeCasino/recordInformeCasino": 1712,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1712,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1713,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1713,
	"./partner/reports/informeCasino/tableInformeCasino": 1714,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1714,
	"./partner/reports/informeGerencial": 1715,
	"./partner/reports/informeGerencial.js": 1715,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 788,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 788,
	"./partner/reports/informeGerencial/filterInformeGerencial": 786,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 786,
	"./partner/reports/informeGerencial/recordInformeGerencial": 789,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 789,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 790,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 790,
	"./partner/reports/informeGerencial/tableInformeGerencial": 787,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 787,
	"./partner/reports/landingReport/detailsLandingReport": 1716,
	"./partner/reports/landingReport/detailsLandingReport.js": 1716,
	"./partner/reports/landingReport/filterLandingReport": 1717,
	"./partner/reports/landingReport/filterLandingReport.js": 1717,
	"./partner/reports/landingReport/recordLandingReport": 1718,
	"./partner/reports/landingReport/recordLandingReport.js": 1718,
	"./partner/reports/landingReport/recordTableLandingReport": 1719,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1719,
	"./partner/reports/landingReport/tableLandingReport": 1720,
	"./partner/reports/landingReport/tableLandingReport.js": 1720,
	"./partner/reports/logsUser/filter": 1721,
	"./partner/reports/logsUser/filter.js": 1721,
	"./partner/reports/logsUser/table": 1722,
	"./partner/reports/logsUser/table.js": 1722,
	"./partner/reports/operatorResponsibility/filter": 1723,
	"./partner/reports/operatorResponsibility/filter.js": 1723,
	"./partner/reports/operatorResponsibility/table": 1724,
	"./partner/reports/operatorResponsibility/table.js": 1724,
	"./partner/reports/paidPendingAwards": 1725,
	"./partner/reports/paidPendingAwards.js": 1725,
	"./partner/reports/playersReport/detailsPlayersReport": 1726,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1726,
	"./partner/reports/playersReport/filterPlayersReport": 1727,
	"./partner/reports/playersReport/filterPlayersReport.js": 1727,
	"./partner/reports/playersReport/recordPlayersReport": 1728,
	"./partner/reports/playersReport/recordPlayersReport.js": 1728,
	"./partner/reports/playersReport/recordTablePlayersReport": 794,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 794,
	"./partner/reports/playersReport/tablePlayersReport": 1729,
	"./partner/reports/playersReport/tablePlayersReport.js": 1729,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1033,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1033,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 791,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 791,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1034,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1034,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 793,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 793,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 792,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 792,
	"./partner/reports/promotionalCodes/filter": 1730,
	"./partner/reports/promotionalCodes/filter.js": 1730,
	"./partner/reports/promotionalCodes/table": 1731,
	"./partner/reports/promotionalCodes/table.js": 1731,
	"./partner/reports/quotaRetraction/filter": 1732,
	"./partner/reports/quotaRetraction/filter.js": 1732,
	"./partner/reports/quotaRetraction/table": 1733,
	"./partner/reports/quotaRetraction/table.js": 1733,
	"./partner/reports/registeredDocument": 1734,
	"./partner/reports/registeredDocument.js": 1734,
	"./partner/reports/registeredDocuments/filter": 795,
	"./partner/reports/registeredDocuments/filter.js": 795,
	"./partner/reports/registeredDocuments/table": 796,
	"./partner/reports/registeredDocuments/table.js": 796,
	"./partner/reports/relationUserAggregator": 1735,
	"./partner/reports/relationUserAggregator.js": 1735,
	"./partner/reports/relationUserAggregator/filter": 797,
	"./partner/reports/relationUserAggregator/filter.js": 797,
	"./partner/reports/relationUserAggregator/table": 798,
	"./partner/reports/relationUserAggregator/table.js": 798,
	"./partner/reports/reportHash/filter": 1736,
	"./partner/reports/reportHash/filter.js": 1736,
	"./partner/reports/reportHash/table": 1737,
	"./partner/reports/reportHash/table.js": 1737,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1738,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1738,
	"./partner/reports/sessionsReport/filterSessionsReport": 1739,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1739,
	"./partner/reports/sessionsReport/recordSessionsReport": 1740,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1740,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1035,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1035,
	"./partner/reports/sessionsReport/tableSessionsReport": 1741,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1741,
	"./partner/reports/sportsTransactions": 1742,
	"./partner/reports/sportsTransactions.js": 1742,
	"./partner/reports/sportsTransactions/filter": 799,
	"./partner/reports/sportsTransactions/filter.js": 799,
	"./partner/reports/sportsTransactions/table": 800,
	"./partner/reports/sportsTransactions/table.js": 800,
	"./partner/reports/summaryCashFlow": 1743,
	"./partner/reports/summaryCashFlow.js": 1743,
	"./partner/reports/taxableEarnings/filter": 1744,
	"./partner/reports/taxableEarnings/filter.js": 1744,
	"./partner/reports/taxableEarnings/table": 1745,
	"./partner/reports/taxableEarnings/table.js": 1745,
	"./partner/reports/transfersReport/filter": 1746,
	"./partner/reports/transfersReport/filter.js": 1746,
	"./partner/reports/transfersReport/table": 1747,
	"./partner/reports/transfersReport/table.js": 1747,
	"./partner/reports/usuarioOnlineResumido": 1748,
	"./partner/reports/usuarioOnlineResumido.js": 1748,
	"./partner/reports/usuarioOnlineResumido/filter": 801,
	"./partner/reports/usuarioOnlineResumido/filter.js": 801,
	"./partner/reports/usuarioOnlineResumido/table": 802,
	"./partner/reports/usuarioOnlineResumido/table.js": 802,
	"./partner/reports/wallets": 1749,
	"./partner/reports/wallets.js": 1749,
	"./partner/reports/wallets/filter": 803,
	"./partner/reports/wallets/filter.js": 803,
	"./partner/reports/wallets/table": 804,
	"./partner/reports/wallets/table.js": 804,
	"./partner/templates": 1750,
	"./partner/templates.js": 1750,
	"./partner/templates/email": 1751,
	"./partner/templates/email.js": 1751,
	"./partner/templates/email/filter": 805,
	"./partner/templates/email/filter.js": 805,
	"./partner/templates/email/table": 806,
	"./partner/templates/email/table.js": 806,
	"./partner/templates/email/template": 807,
	"./partner/templates/email/template.js": 807,
	"./partner/templates/emailTemplate": 1752,
	"./partner/templates/emailTemplate.js": 1752,
	"./partner/templates/pdf": 1753,
	"./partner/templates/pdf.js": 1753,
	"./partner/templates/pdf/filter": 808,
	"./partner/templates/pdf/filter.js": 808,
	"./partner/templates/pdf/table": 809,
	"./partner/templates/pdf/table.js": 809,
	"./partner/templates/pdf/template": 810,
	"./partner/templates/pdf/template.js": 810,
	"./partner/templates/pdfTemplate": 1754,
	"./partner/templates/pdfTemplate.js": 1754,
	"./partner/templates/sms": 1755,
	"./partner/templates/sms.js": 1755,
	"./partner/templates/sms/filter": 811,
	"./partner/templates/sms/filter.js": 811,
	"./partner/templates/sms/table": 812,
	"./partner/templates/sms/table.js": 812,
	"./partner/templates/sms/template": 813,
	"./partner/templates/sms/template.js": 813,
	"./partner/templates/smsTemplate": 1756,
	"./partner/templates/smsTemplate.js": 1756,
	"./partners": 1757,
	"./partners.js": 1757,
	"./partnersCategories": 1758,
	"./partnersCategories.js": 1758,
	"./partnersProducts": 1759,
	"./partnersProducts.js": 1759,
	"./partnersProductsCountry": 1760,
	"./partnersProductsCountry.js": 1760,
	"./partnersProviders": 1761,
	"./partnersProviders.js": 1761,
	"./partnersTypeProduct": 1762,
	"./partnersTypeProduct.js": 1762,
	"./payPrizesLoyalty": 1763,
	"./payPrizesLoyalty.js": 1763,
	"./payhistoryview": 1764,
	"./payhistoryview.js": 1764,
	"./platformSpecific": 1765,
	"./platformSpecific.js": 1765,
	"./platformSpecific2": 1766,
	"./platformSpecific2.js": 1766,
	"./playerAccount": 1767,
	"./playerAccount.js": 1767,
	"./playerAccount2": 1768,
	"./playerAccount2.js": 1768,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1769,
	"./playersList.js": 1769,
	"./playersList2": 1770,
	"./playersList2.js": 1770,
	"./playersListAggregator": 1771,
	"./playersListAggregator.js": 1771,
	"./playersLists": 1772,
	"./playersLists.js": 1772,
	"./playersReport": 1773,
	"./playersReport.js": 1773,
	"./pointSettings": 1774,
	"./pointSettings.js": 1774,
	"./pointsUsers": 1775,
	"./pointsUsers.js": 1775,
	"./pokerReport": 1776,
	"./pokerReport.js": 1776,
	"./prices": 1777,
	"./prices.js": 1777,
	"./prizesLoyalty": 1778,
	"./prizesLoyalty.js": 1778,
	"./products": 1779,
	"./products.js": 1779,
	"./products/activeProviders/filterActiveProviders": 205,
	"./products/activeProviders/filterActiveProviders.js": 205,
	"./products/activeProviders/tableActiveProviders": 206,
	"./products/activeProviders/tableActiveProviders.js": 206,
	"./products/banks/filterBanks": 323,
	"./products/banks/filterBanks.js": 323,
	"./products/banks/tableBanks": 324,
	"./products/banks/tableBanks.js": 324,
	"./products/blockchain-networks/filterBlockchainNetworks": 380,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 380,
	"./products/blockchain-networks/tableBlockchainNetworks": 381,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 381,
	"./products/categories-products/detailsCategoriesProducts": 1018,
	"./products/categories-products/detailsCategoriesProducts.js": 1018,
	"./products/categories-products/filterCategoriesProducts": 425,
	"./products/categories-products/filterCategoriesProducts.js": 425,
	"./products/categories-products/recordCategoriesProducts": 1019,
	"./products/categories-products/recordCategoriesProducts.js": 1019,
	"./products/categories-products/recordTableCategoriesProducts": 427,
	"./products/categories-products/recordTableCategoriesProducts.js": 427,
	"./products/categories-products/tableCategoriesProducts": 426,
	"./products/categories-products/tableCategoriesProducts.js": 426,
	"./products/categories/detailsCategories": 1016,
	"./products/categories/detailsCategories.js": 1016,
	"./products/categories/filterCategories": 422,
	"./products/categories/filterCategories.js": 422,
	"./products/categories/recordCategories": 1017,
	"./products/categories/recordCategories.js": 1017,
	"./products/categories/recordTableCategories": 424,
	"./products/categories/recordTableCategories.js": 424,
	"./products/categories/tableCategories": 423,
	"./products/categories/tableCategories.js": 423,
	"./products/crypto-blockchain/filterCryptoBlockchain": 449,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 449,
	"./products/crypto-blockchain/tableCryptoBlockchain": 450,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 450,
	"./products/cryptos/filterCrypto": 451,
	"./products/cryptos/filterCrypto.js": 451,
	"./products/cryptos/tableCrypto": 452,
	"./products/cryptos/tableCrypto.js": 452,
	"./products/franchises/filterFranchises": 518,
	"./products/franchises/filterFranchises.js": 518,
	"./products/franchises/tableFranchises": 519,
	"./products/franchises/tableFranchises.js": 519,
	"./products/partners-products-country/detailsPartnersProductsCountry": 824,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 824,
	"./products/partners-products-country/filterPartnersProductsCountry": 822,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 822,
	"./products/partners-products-country/recordPartnersProductsCountry": 825,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 825,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 826,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 826,
	"./products/partners-products-country/tablePartnersProductsCountry": 823,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 823,
	"./products/partners-products/detailsPartnersProducts": 820,
	"./products/partners-products/detailsPartnersProducts.js": 820,
	"./products/partners-products/filterPartnersProducts": 818,
	"./products/partners-products/filterPartnersProducts.js": 818,
	"./products/partners-products/recordPartnersProducts": 821,
	"./products/partners-products/recordPartnersProducts.js": 821,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 819,
	"./products/partners-products/tablePartnersProducts.js": 819,
	"./products/partners-providers/details": 829,
	"./products/partners-providers/details.js": 829,
	"./products/partners-providers/filter": 827,
	"./products/partners-providers/filter.js": 827,
	"./products/partners-providers/record": 830,
	"./products/partners-providers/record.js": 830,
	"./products/partners-providers/recordTable": 1780,
	"./products/partners-providers/recordTable.js": 1780,
	"./products/partners-providers/table": 828,
	"./products/partners-providers/table.js": 828,
	"./products/partners-tipoproducto/details": 833,
	"./products/partners-tipoproducto/details.js": 833,
	"./products/partners-tipoproducto/filter": 831,
	"./products/partners-tipoproducto/filter.js": 831,
	"./products/partners-tipoproducto/record": 834,
	"./products/partners-tipoproducto/record.js": 834,
	"./products/partners-tipoproducto/recordTable": 1781,
	"./products/partners-tipoproducto/recordTable.js": 1781,
	"./products/partners-tipoproducto/table": 832,
	"./products/partners-tipoproducto/table.js": 832,
	"./products/partners/filter": 814,
	"./products/partners/filter.js": 814,
	"./products/partners/table": 815,
	"./products/partners/table.js": 815,
	"./products/products/detailsProducts": 1036,
	"./products/products/detailsProducts.js": 1036,
	"./products/products/filterProducts": 856,
	"./products/products/filterProducts.js": 856,
	"./products/products/recordProducts": 1037,
	"./products/products/recordProducts.js": 1037,
	"./products/products/recordTableProducts": 858,
	"./products/products/recordTableProducts.js": 858,
	"./products/products/tableProducts": 857,
	"./products/products/tableProducts.js": 857,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 859,
	"./products/providers/filterProviders.js": 859,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 325,
	"./products/providers/recordTableProviders.js": 325,
	"./products/providers/tableProviders": 860,
	"./products/providers/tableProviders.js": 860,
	"./products/subProviders/filter": 861,
	"./products/subProviders/filter.js": 861,
	"./products/subProviders/table": 862,
	"./products/subProviders/table.js": 862,
	"./products/tags/detailsTags": 1038,
	"./products/tags/detailsTags.js": 1038,
	"./products/tags/filterTags": 863,
	"./products/tags/filterTags.js": 863,
	"./products/tags/recordTableTags": 864,
	"./products/tags/recordTableTags.js": 864,
	"./products/tags/recordTags": 1039,
	"./products/tags/recordTags.js": 1039,
	"./products/tags/tableTags": 865,
	"./products/tags/tableTags.js": 865,
	"./profile": 1782,
	"./profile.js": 1782,
	"./profileOptions": 1783,
	"./profileOptions.js": 1783,
	"./profileOptions2": 1784,
	"./profileOptions2.js": 1784,
	"./profileOptionsOld": 1785,
	"./profileOptionsOld.js": 1785,
	"./promotionalCasinoCampaings": 1786,
	"./promotionalCasinoCampaings.js": 1786,
	"./promotionalCodes": 1787,
	"./promotionalCodes.js": 1787,
	"./promotionalSportbookCampaings": 1788,
	"./promotionalSportbookCampaings.js": 1788,
	"./providers": 1789,
	"./providers.js": 1789,
	"./qualifying": 1790,
	"./qualifying.js": 1790,
	"./quotaRetraction": 1791,
	"./quotaRetraction.js": 1791,
	"./quotaRetractionReport": 1792,
	"./quotaRetractionReport.js": 1792,
	"./recargarCredito": 1793,
	"./recargarCredito.js": 1793,
	"./recargarCreditoAgente": 1794,
	"./recargarCreditoAgente.js": 1794,
	"./referralsAwardsReport": 1795,
	"./referralsAwardsReport.js": 1795,
	"./referralsReport": 1796,
	"./referralsReport.js": 1796,
	"./registerFast": 1797,
	"./registerFast.js": 1797,
	"./registeredDocument": 1798,
	"./registeredDocument.js": 1798,
	"./registeredDocuments": 1799,
	"./registeredDocuments.js": 1799,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 438,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 438,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 439,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 439,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 440,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 440,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 441,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 441,
	"./regulations/futureEvents/filterFutureEventsReports": 520,
	"./regulations/futureEvents/filterFutureEventsReports.js": 520,
	"./regulations/futureEvents/tableFutureEventsReports": 521,
	"./regulations/futureEvents/tableFutureEventsReports.js": 521,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 522,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 522,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 523,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 523,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 524,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 524,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 525,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 525,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 551,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 551,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 552,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 552,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 553,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 553,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 554,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 554,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 555,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 555,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 556,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 556,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 557,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 557,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 558,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 558,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 680,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 680,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 681,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 681,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 682,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 682,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 683,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 683,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 835,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 835,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 836,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 836,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 837,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 837,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 838,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 838,
	"./regulations/playerAccount/filterPlayerAccountReports": 839,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 839,
	"./regulations/playerAccount/tablePlayerAccountReports": 840,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 840,
	"./regulations/playerAccount2/filterPlayerAccountReports": 841,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 841,
	"./regulations/playerAccount2/tablePlayerAccountReports": 842,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 842,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 890,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 890,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 891,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 891,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 892,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 892,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 893,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 893,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 894,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 894,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 895,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 895,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 896,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 896,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 897,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 897,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 898,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 898,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 899,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 899,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 900,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 900,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 901,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 901,
	"./relationUserAggregator": 1800,
	"./relationUserAggregator.js": 1800,
	"./reportHash": 1801,
	"./reportHash.js": 1801,
	"./reportMarketing": 1802,
	"./reportMarketing.js": 1802,
	"./reports/affiliatesBetShop/filter": 209,
	"./reports/affiliatesBetShop/filter.js": 209,
	"./reports/affiliatesBetShop/table": 210,
	"./reports/affiliatesBetShop/table.js": 210,
	"./reports/assignmentQuota/filter": 294,
	"./reports/assignmentQuota/filter.js": 294,
	"./reports/assignmentQuota/table": 295,
	"./reports/assignmentQuota/table.js": 295,
	"./reports/assignmentQuotaMade/filter": 292,
	"./reports/assignmentQuotaMade/filter.js": 292,
	"./reports/assignmentQuotaMade/table": 293,
	"./reports/assignmentQuotaMade/table.js": 293,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 298,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 299,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 297,
	"./reports/balanceAdjustments/filter": 300,
	"./reports/balanceAdjustments/filter.js": 300,
	"./reports/balanceAdjustments/table": 301,
	"./reports/balanceAdjustments/table.js": 301,
	"./reports/balanceHistory/filter": 302,
	"./reports/balanceHistory/filter.js": 302,
	"./reports/balanceHistory/table": 303,
	"./reports/balanceHistory/table.js": 303,
	"./reports/balanceHistory2/filter": 1803,
	"./reports/balanceHistory2/filter.js": 1803,
	"./reports/balanceHistory2/filter2": 304,
	"./reports/balanceHistory2/filter2.js": 304,
	"./reports/balanceHistory2/table": 1804,
	"./reports/balanceHistory2/table.js": 1804,
	"./reports/balanceHistory2/table2": 305,
	"./reports/balanceHistory2/table2.js": 305,
	"./reports/balanceHistoryBetShop/filter": 308,
	"./reports/balanceHistoryBetShop/filter.js": 308,
	"./reports/balanceHistoryBetShop/table": 309,
	"./reports/balanceHistoryBetShop/table.js": 309,
	"./reports/balanceHistoryBetShop2/filter": 1805,
	"./reports/balanceHistoryBetShop2/filter.js": 1805,
	"./reports/balanceHistoryBetShop2/filter2": 310,
	"./reports/balanceHistoryBetShop2/filter2.js": 310,
	"./reports/balanceHistoryBetShop2/table": 1806,
	"./reports/balanceHistoryBetShop2/table.js": 1806,
	"./reports/balanceHistoryBetShop2/table2": 311,
	"./reports/balanceHistoryBetShop2/table2.js": 311,
	"./reports/balanceHistoryForAdminUser/filter": 306,
	"./reports/balanceHistoryForAdminUser/filter.js": 306,
	"./reports/balanceHistoryForAdminUser/table": 307,
	"./reports/balanceHistoryForAdminUser/table.js": 307,
	"./reports/balanceHistoryForAgent/filter": 312,
	"./reports/balanceHistoryForAgent/filter.js": 312,
	"./reports/balanceHistoryForAgent/table": 313,
	"./reports/balanceHistoryForAgent/table.js": 313,
	"./reports/balanceHistoryForBetShop/filter": 314,
	"./reports/balanceHistoryForBetShop/filter.js": 314,
	"./reports/balanceHistoryForBetShop/table": 315,
	"./reports/balanceHistoryForBetShop/table.js": 315,
	"./reports/balanceHistoryMachine/filter": 316,
	"./reports/balanceHistoryMachine/filter.js": 316,
	"./reports/balanceHistoryMachine/table": 317,
	"./reports/balanceHistoryMachine/table.js": 317,
	"./reports/balanceUsers/filter": 318,
	"./reports/balanceUsers/filter.js": 318,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 320,
	"./reports/balanceUsers/resume.js": 320,
	"./reports/balanceUsers/table": 319,
	"./reports/balanceUsers/table.js": 319,
	"./reports/betsReport/detailsReport": 1807,
	"./reports/betsReport/detailsReport.js": 1807,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1808,
	"./reports/betsReportBetShop/detailsReport.js": 1808,
	"./reports/betsReportBetShop/filterReport": 374,
	"./reports/betsReportBetShop/filterReport.js": 374,
	"./reports/betsReportBetShop/recordReport": 377,
	"./reports/betsReportBetShop/recordReport.js": 377,
	"./reports/betsReportBetShop/recordTableReport": 1809,
	"./reports/betsReportBetShop/recordTableReport.js": 1809,
	"./reports/betsReportBetShop/recordTableTransReport": 1810,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1810,
	"./reports/betsReportBetShop/recordTransReport": 376,
	"./reports/betsReportBetShop/recordTransReport.js": 376,
	"./reports/betsReportBetShop/tableReport": 375,
	"./reports/betsReportBetShop/tableReport.js": 375,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 382,
	"./reports/bonusReport/filterBonusReport.js": 382,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 383,
	"./reports/bonusReport/tableBonusReport.js": 383,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 384,
	"./reports/bonusReport2/filterBonusReport.js": 384,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1811,
	"./reports/bonusReport2/recordTableBonusReport.js": 1811,
	"./reports/bonusReport2/tableBonusReport": 385,
	"./reports/bonusReport2/tableBonusReport.js": 385,
	"./reports/bonusReports2/filter": 386,
	"./reports/bonusReports2/filter.js": 386,
	"./reports/bonusReports2/table": 387,
	"./reports/bonusReports2/table.js": 387,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 418,
	"./reports/casinoReport/filterCasinoReport.js": 418,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 419,
	"./reports/casinoReport/tableCasinoReport.js": 419,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1812,
	"./reports/casinoReport2/filterCasinoReport.js": 1812,
	"./reports/casinoReport2/filterCasinoReport2": 420,
	"./reports/casinoReport2/filterCasinoReport2.js": 420,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1813,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1813,
	"./reports/casinoReport2/tableCasinoReport": 1814,
	"./reports/casinoReport2/tableCasinoReport.js": 1814,
	"./reports/casinoReport2/tableCasinoReport2": 421,
	"./reports/casinoReport2/tableCasinoReport2.js": 421,
	"./reports/comissions_report/filter": 428,
	"./reports/comissions_report/filter.js": 428,
	"./reports/comissions_report/table": 429,
	"./reports/comissions_report/table.js": 429,
	"./reports/comissions_report2/filter": 430,
	"./reports/comissions_report2/filter.js": 430,
	"./reports/comissions_report2/table": 431,
	"./reports/comissions_report2/table.js": 431,
	"./reports/commisionsPay/filter": 432,
	"./reports/commisionsPay/filter.js": 432,
	"./reports/commisionsPay/table": 433,
	"./reports/commisionsPay/table.js": 433,
	"./reports/coupons_report/details": 1815,
	"./reports/coupons_report/details.js": 1815,
	"./reports/coupons_report/filter": 447,
	"./reports/coupons_report/filter.js": 447,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1816,
	"./reports/coupons_report/recordReports.js": 1816,
	"./reports/coupons_report/table": 448,
	"./reports/coupons_report/table.js": 448,
	"./reports/customReport/filter": 453,
	"./reports/customReport/filter.js": 453,
	"./reports/customReport/table": 454,
	"./reports/customReport/table.js": 454,
	"./reports/depositReport2/filter": 499,
	"./reports/depositReport2/filter.js": 499,
	"./reports/depositReport2/table": 500,
	"./reports/depositReport2/table.js": 500,
	"./reports/deposit_report/detailsDepositReports": 1024,
	"./reports/deposit_report/detailsDepositReports.js": 1024,
	"./reports/deposit_report/filterDepositReports": 497,
	"./reports/deposit_report/filterDepositReports.js": 497,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 498,
	"./reports/deposit_report/tableDepositReports.js": 498,
	"./reports/deposit_report_3/detailsDepositReports": 1025,
	"./reports/deposit_report_3/detailsDepositReports.js": 1025,
	"./reports/deposit_report_3/filterDepositReports": 501,
	"./reports/deposit_report_3/filterDepositReports.js": 501,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1817,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1817,
	"./reports/deposit_report_3/tableDepositReports": 502,
	"./reports/deposit_report_3/tableDepositReports.js": 502,
	"./reports/deposit_report_betshop/detailsDepositReports": 1026,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1026,
	"./reports/deposit_report_betshop/filterDepositReports": 503,
	"./reports/deposit_report_betshop/filterDepositReports.js": 503,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1818,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1818,
	"./reports/deposit_report_betshop/tableDepositReports": 504,
	"./reports/deposit_report_betshop/tableDepositReports.js": 504,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 512,
	"./reports/emailsReport/filterEmailsReport.js": 512,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1819,
	"./reports/emailsReport/recordTableEmailsReport.js": 1819,
	"./reports/emailsReport/tableEmailsReport": 513,
	"./reports/emailsReport/tableEmailsReport.js": 513,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 908,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 908,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 909,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 909,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 910,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 910,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 911,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 911,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 912,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 912,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1820,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1820,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 913,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 913,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 914,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1821,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1821,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1822,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1822,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 915,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 915,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 916,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 916,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 917,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 917,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 918,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 918,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1823,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1823,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 919,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 919,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 528,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 528,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 526,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 526,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 529,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 529,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 530,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 530,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 527,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 527,
	"./reports/historyMovement/filter": 531,
	"./reports/historyMovement/filter.js": 531,
	"./reports/historyMovement/table": 532,
	"./reports/historyMovement/table.js": 532,
	"./reports/historyMovementBetShop/filter": 533,
	"./reports/historyMovementBetShop/filter.js": 533,
	"./reports/historyMovementBetShop/table": 534,
	"./reports/historyMovementBetShop/table.js": 534,
	"./reports/historyPoints/filter": 535,
	"./reports/historyPoints/filter.js": 535,
	"./reports/historyPoints/table": 536,
	"./reports/historyPoints/table.js": 536,
	"./reports/informeCasino/detailsInformeCasino": 539,
	"./reports/informeCasino/detailsInformeCasino.js": 539,
	"./reports/informeCasino/filterInformeCasino": 537,
	"./reports/informeCasino/filterInformeCasino.js": 537,
	"./reports/informeCasino/recordInformeCasino": 540,
	"./reports/informeCasino/recordInformeCasino.js": 540,
	"./reports/informeCasino/recordTableInformeCasino": 1824,
	"./reports/informeCasino/recordTableInformeCasino.js": 1824,
	"./reports/informeCasino/tableInformeCasino": 538,
	"./reports/informeCasino/tableInformeCasino.js": 538,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome": 437,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome.js": 437,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome": 436,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome.js": 436,
	"./reports/informeGerencial/detailsInformeGerencial": 1825,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1825,
	"./reports/informeGerencial/filterInformeGerencial": 541,
	"./reports/informeGerencial/filterInformeGerencial.js": 541,
	"./reports/informeGerencial/recordInformeGerencial": 1826,
	"./reports/informeGerencial/recordInformeGerencial.js": 1826,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 542,
	"./reports/informeGerencial/tableInformeGerencial.js": 542,
	"./reports/informeGerencial2/detailsInformeGerencial": 1827,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1827,
	"./reports/informeGerencial2/filterInformeGerencial": 1828,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1828,
	"./reports/informeGerencial2/filterInformeGerencial2": 543,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 543,
	"./reports/informeGerencial2/recordInformeGerencial": 1829,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1829,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1830,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1830,
	"./reports/informeGerencial2/tableInformeGerencial": 1831,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1831,
	"./reports/informeGerencial2/tableInformeGerencial2": 544,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 544,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1832,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1832,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1833,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1833,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 545,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 545,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1834,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1834,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1835,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1835,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1836,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1836,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 546,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 546,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1837,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1837,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1838,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1838,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 547,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 547,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1839,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1839,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1840,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1840,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1841,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1841,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 548,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 548,
	"./reports/jackpotInternationalReport/filter": 549,
	"./reports/jackpotInternationalReport/filter.js": 549,
	"./reports/jackpotInternationalReport/table": 550,
	"./reports/jackpotInternationalReport/table.js": 550,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 559,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 559,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1842,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1842,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1843,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1843,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 560,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 560,
	"./reports/landingReport/detailsLandingReport": 563,
	"./reports/landingReport/detailsLandingReport.js": 563,
	"./reports/landingReport/filterLandingReport": 561,
	"./reports/landingReport/filterLandingReport.js": 561,
	"./reports/landingReport/recordLandingReport": 564,
	"./reports/landingReport/recordLandingReport.js": 564,
	"./reports/landingReport/recordTableLandingReport": 1844,
	"./reports/landingReport/recordTableLandingReport.js": 1844,
	"./reports/landingReport/tableLandingReport": 562,
	"./reports/landingReport/tableLandingReport.js": 562,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 565,
	"./reports/landingReport2/filterLandingReport.js": 565,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1845,
	"./reports/landingReport2/recordTableLandingReport.js": 1845,
	"./reports/landingReport2/tableLandingReport": 566,
	"./reports/landingReport2/tableLandingReport.js": 566,
	"./reports/limitationsReport/filterDepositReports": 583,
	"./reports/limitationsReport/filterDepositReports.js": 583,
	"./reports/limitationsReport/tableDepositReports": 584,
	"./reports/limitationsReport/tableDepositReports.js": 584,
	"./reports/logsUser/filter": 587,
	"./reports/logsUser/filter.js": 587,
	"./reports/logsUser/table": 588,
	"./reports/logsUser/table.js": 588,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 589,
	"./reports/loteryReport/filterLoteryReport.js": 589,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1846,
	"./reports/loteryReport/recordTableLoteryReport.js": 1846,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 590,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 590,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 591,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 591,
	"./reports/my_comissions_report/filter": 674,
	"./reports/my_comissions_report/filter.js": 674,
	"./reports/my_comissions_report/table": 675,
	"./reports/my_comissions_report/table.js": 675,
	"./reports/notesUser/filter": 676,
	"./reports/notesUser/filter.js": 676,
	"./reports/notesUser/table": 677,
	"./reports/notesUser/table.js": 677,
	"./reports/operatorResponsibility/filter": 678,
	"./reports/operatorResponsibility/filter.js": 678,
	"./reports/operatorResponsibility/table": 679,
	"./reports/operatorResponsibility/table.js": 679,
	"./reports/partners-categories/filter": 816,
	"./reports/partners-categories/filter.js": 816,
	"./reports/partners-categories/table": 817,
	"./reports/partners-categories/table.js": 817,
	"./reports/playersReport/detailsPlayersReport": 845,
	"./reports/playersReport/detailsPlayersReport.js": 845,
	"./reports/playersReport/filterPlayersReport": 843,
	"./reports/playersReport/filterPlayersReport.js": 843,
	"./reports/playersReport/recordPlayersReport": 846,
	"./reports/playersReport/recordPlayersReport.js": 846,
	"./reports/playersReport/recordTablePlayersReport": 847,
	"./reports/playersReport/recordTablePlayersReport.js": 847,
	"./reports/playersReport/tablePlayersReport": 844,
	"./reports/playersReport/tablePlayersReport.js": 844,
	"./reports/pointSettings/filter": 848,
	"./reports/pointSettings/filter.js": 848,
	"./reports/pointSettings/table": 849,
	"./reports/pointSettings/table.js": 849,
	"./reports/pointsUsers/filter": 850,
	"./reports/pointsUsers/filter.js": 850,
	"./reports/pointsUsers/table": 851,
	"./reports/pointsUsers/table.js": 851,
	"./reports/pokerReport/filterCasinoReport": 852,
	"./reports/pokerReport/filterCasinoReport.js": 852,
	"./reports/pokerReport/tableCasinoReport": 853,
	"./reports/pokerReport/tableCasinoReport.js": 853,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1847,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1847,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 684,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 684,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1848,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1848,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 920,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 920,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 685,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 685,
	"./reports/prizesLoyalty/filter": 854,
	"./reports/prizesLoyalty/filter.js": 854,
	"./reports/prizesLoyalty/table": 855,
	"./reports/prizesLoyalty/table.js": 855,
	"./reports/promotionalCasinoCampaings/filter": 871,
	"./reports/promotionalCasinoCampaings/filter.js": 871,
	"./reports/promotionalCasinoCampaings/table": 872,
	"./reports/promotionalCasinoCampaings/table.js": 872,
	"./reports/promotionalCodes/filter": 873,
	"./reports/promotionalCodes/filter.js": 873,
	"./reports/promotionalCodes/table": 874,
	"./reports/promotionalCodes/table.js": 874,
	"./reports/promotionalSpoortbookCampaings/filter": 875,
	"./reports/promotionalSpoortbookCampaings/filter.js": 875,
	"./reports/promotionalSpoortbookCampaings/table": 876,
	"./reports/promotionalSpoortbookCampaings/table.js": 876,
	"./reports/quotaRetraction/filter": 879,
	"./reports/quotaRetraction/filter.js": 879,
	"./reports/quotaRetraction/table": 880,
	"./reports/quotaRetraction/table.js": 880,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 881,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 881,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1849,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1849,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1850,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1850,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 882,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 882,
	"./reports/referralsReport/filterReferralsReports": 883,
	"./reports/referralsReport/filterReferralsReports.js": 883,
	"./reports/referralsReport/recordReferralsReports": 1851,
	"./reports/referralsReport/recordReferralsReports.js": 1851,
	"./reports/referralsReport/recordTableReferralsReports": 1852,
	"./reports/referralsReport/recordTableReferralsReports.js": 1852,
	"./reports/referralsReport/tableReferralsReports": 884,
	"./reports/referralsReport/tableReferralsReports.js": 884,
	"./reports/registeredDocuments/filter": 885,
	"./reports/registeredDocuments/filter.js": 885,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 887,
	"./reports/registeredDocuments/recordTable.js": 887,
	"./reports/registeredDocuments/table": 886,
	"./reports/registeredDocuments/table.js": 886,
	"./reports/relationUserAggregator/filter": 902,
	"./reports/relationUserAggregator/filter.js": 902,
	"./reports/relationUserAggregator/table": 903,
	"./reports/relationUserAggregator/table.js": 903,
	"./reports/reportHash/filter": 904,
	"./reports/reportHash/filter.js": 904,
	"./reports/reportHash/table": 905,
	"./reports/reportHash/table.js": 905,
	"./reports/reportMarketing/filter": 906,
	"./reports/reportMarketing/filter.js": 906,
	"./reports/reportMarketing/table": 907,
	"./reports/reportMarketing/table.js": 907,
	"./reports/rouletteReport/filter": 921,
	"./reports/rouletteReport/filter.js": 921,
	"./reports/rouletteReport/table": 922,
	"./reports/rouletteReport/table.js": 922,
	"./reports/sessionsReport/detailsSessionsReport": 923,
	"./reports/sessionsReport/detailsSessionsReport.js": 923,
	"./reports/sessionsReport/filterSessionsReport": 924,
	"./reports/sessionsReport/filterSessionsReport.js": 924,
	"./reports/sessionsReport/recordSessionsReport": 1040,
	"./reports/sessionsReport/recordSessionsReport.js": 1040,
	"./reports/sessionsReport/recordTableSessionsReport": 1041,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1041,
	"./reports/sessionsReport/tableSessionsReport": 925,
	"./reports/sessionsReport/tableSessionsReport.js": 925,
	"./reports/sessionsReport2/filter": 926,
	"./reports/sessionsReport2/filter.js": 926,
	"./reports/sessionsReport2/table": 927,
	"./reports/sessionsReport2/table.js": 927,
	"./reports/sportsPoolReport/filterReport": 928,
	"./reports/sportsPoolReport/filterReport.js": 928,
	"./reports/sportsPoolReport/tableReport": 929,
	"./reports/sportsPoolReport/tableReport.js": 929,
	"./reports/sportsTransactions/filter": 930,
	"./reports/sportsTransactions/filter.js": 930,
	"./reports/sportsTransactions/table": 931,
	"./reports/sportsTransactions/table.js": 931,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 932,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 932,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 933,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 933,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 934,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 934,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1853,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1853,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 935,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 935,
	"./reports/taxPaymentsReport/filter": 936,
	"./reports/taxPaymentsReport/filter.js": 936,
	"./reports/taxPaymentsReport/table": 937,
	"./reports/taxPaymentsReport/table.js": 937,
	"./reports/taxableEarnings/filter": 938,
	"./reports/taxableEarnings/filter.js": 938,
	"./reports/taxableEarnings/table": 939,
	"./reports/taxableEarnings/table.js": 939,
	"./reports/transactionReport/filter": 940,
	"./reports/transactionReport/filter.js": 940,
	"./reports/transactionReport/table": 941,
	"./reports/transactionReport/table.js": 941,
	"./reports/transfersReport/filter": 942,
	"./reports/transfersReport/filter.js": 942,
	"./reports/transfersReport/table": 943,
	"./reports/transfersReport/table.js": 943,
	"./reports/userAffiliatesAgent/filter": 944,
	"./reports/userAffiliatesAgent/filter.js": 944,
	"./reports/userAffiliatesAgent/table": 945,
	"./reports/userAffiliatesAgent/table.js": 945,
	"./reports/userAffiliatesBetShop/filter": 946,
	"./reports/userAffiliatesBetShop/filter.js": 946,
	"./reports/userAffiliatesBetShop/table": 947,
	"./reports/userAffiliatesBetShop/table.js": 947,
	"./reports/usuarioOnlineResumido/filter": 948,
	"./reports/usuarioOnlineResumido/filter.js": 948,
	"./reports/usuarioOnlineResumido/table": 949,
	"./reports/usuarioOnlineResumido/table.js": 949,
	"./reports/withdrawalReport2/filter": 950,
	"./reports/withdrawalReport2/filter.js": 950,
	"./reports/withdrawalReport2/table": 951,
	"./reports/withdrawalReport2/table.js": 951,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 952,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 952,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 953,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 953,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1854,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1854,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 954,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 954,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 955,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 955,
	"./reports/withdrawalRequestsComissions/filter": 956,
	"./reports/withdrawalRequestsComissions/filter.js": 956,
	"./reports/withdrawalRequestsComissions/table": 957,
	"./reports/withdrawalRequestsComissions/table.js": 957,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 958,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 958,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 959,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 959,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 960,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 960,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1855,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1855,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 961,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 961,
	"./reprintCheck": 1856,
	"./reprintCheck.js": 1856,
	"./requests/registration-requests/filter": 962,
	"./requests/registration-requests/filter.js": 962,
	"./requests/registration-requests/generateRequests": 963,
	"./requests/registration-requests/generateRequests.js": 963,
	"./requests/registration-requests/recordTableResponts": 964,
	"./requests/registration-requests/recordTableResponts.js": 964,
	"./requests/registration-requests/table": 966,
	"./requests/registration-requests/table.js": 966,
	"./requests/registration-requests/tableResponts": 965,
	"./requests/registration-requests/tableResponts.js": 965,
	"./requests/registrationRequests": 1857,
	"./requests/registrationRequests.js": 1857,
	"./resources-locale_es.json": 1959,
	"./restrictUser": 1858,
	"./restrictUser.js": 1858,
	"./reversionReload": 1859,
	"./reversionReload.js": 1859,
	"./rouletteReport": 1860,
	"./rouletteReport.js": 1860,
	"./security/adminuser/addAdminUser": 1861,
	"./security/adminuser/addAdminUser.js": 1861,
	"./security/adminuser/configuration/changePassword": 1862,
	"./security/adminuser/configuration/changePassword.js": 1862,
	"./security/adminuser/configuration/changePassword/changePasswordView": 967,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 967,
	"./security/adminuser/configuration/generateToken": 1863,
	"./security/adminuser/configuration/generateToken.js": 1863,
	"./security/adminuser/configuration/generateToken/filter": 968,
	"./security/adminuser/configuration/generateToken/filter.js": 968,
	"./security/adminuser/configuration/generateToken/table": 969,
	"./security/adminuser/configuration/generateToken/table.js": 969,
	"./security/adminuser/configuration/qrgoogle": 1864,
	"./security/adminuser/configuration/qrgoogle.js": 1864,
	"./security/adminuser/configuration/securityChanges": 1865,
	"./security/adminuser/configuration/securityChanges.js": 1865,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1866,
	"./security/adminuser/configurationAdminUser.js": 1866,
	"./security/adminuser/detailsAdminUser": 1867,
	"./security/adminuser/detailsAdminUser.js": 1867,
	"./security/adminuser/filterAdminUser": 207,
	"./security/adminuser/filterAdminUser.js": 207,
	"./security/adminuser/informationAdminUser": 1868,
	"./security/adminuser/informationAdminUser.js": 1868,
	"./security/adminuser/recordAdminUser": 1869,
	"./security/adminuser/recordAdminUser.js": 1869,
	"./security/adminuser/recordTableAdminUser": 970,
	"./security/adminuser/recordTableAdminUser.js": 970,
	"./security/adminuser/reports/logsUser": 1870,
	"./security/adminuser/reports/logsUser.js": 1870,
	"./security/adminuser/reports/logsUser/filter": 971,
	"./security/adminuser/reports/logsUser/filter.js": 971,
	"./security/adminuser/reports/logsUser/table": 972,
	"./security/adminuser/reports/logsUser/table.js": 972,
	"./security/adminuser/reportsAdminUser": 1871,
	"./security/adminuser/reportsAdminUser.js": 1871,
	"./security/adminuser/tableAdminUser": 208,
	"./security/adminuser/tableAdminUser.js": 208,
	"./security/approvalLogs/filter": 286,
	"./security/approvalLogs/filter.js": 286,
	"./security/approvalLogs/table": 287,
	"./security/approvalLogs/table.js": 287,
	"./security/approvalLogs2/filter": 288,
	"./security/approvalLogs2/filter.js": 288,
	"./security/approvalLogs2/table": 289,
	"./security/approvalLogs2/table.js": 289,
	"./security/approvalLogsBetShop/filter": 290,
	"./security/approvalLogsBetShop/filter.js": 290,
	"./security/approvalLogsBetShop/table": 291,
	"./security/approvalLogsBetShop/table.js": 291,
	"./security/contingencia/detailsContingencia": 1872,
	"./security/contingencia/detailsContingencia.js": 1872,
	"./security/contingencia/filterContingencia": 442,
	"./security/contingencia/filterContingencia.js": 442,
	"./security/contingencia/recordContingencia": 1873,
	"./security/contingencia/recordContingencia.js": 1873,
	"./security/contingencia/recordTableContingencia": 973,
	"./security/contingencia/recordTableContingencia.js": 973,
	"./security/contingencia/tableContingencia": 443,
	"./security/contingencia/tableContingencia.js": 443,
	"./security/menu/filter": 664,
	"./security/menu/filter.js": 664,
	"./security/menu/table": 665,
	"./security/menu/table.js": 665,
	"./security/perfil/detailsPerfil": 868,
	"./security/perfil/detailsPerfil.js": 868,
	"./security/perfil/filterPerfil": 866,
	"./security/perfil/filterPerfil.js": 866,
	"./security/perfil/recordPerfil": 869,
	"./security/perfil/recordPerfil.js": 869,
	"./security/perfil/recordTablePerfil": 870,
	"./security/perfil/recordTablePerfil.js": 870,
	"./security/perfil/tablePerfil": 867,
	"./security/perfil/tablePerfil.js": 867,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1874,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1874,
	"./security/perfilopciones2/filterPerfilOpciones": 1875,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1875,
	"./security/perfilopciones2/recordPerfilOpciones": 1876,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1876,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1877,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1877,
	"./security/perfilopciones2/tablePerfilOpciones": 1878,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1878,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1879,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1879,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1880,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1880,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1881,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1881,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1882,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1882,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1883,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1883,
	"./security/submenu/detailsSubMenu": 974,
	"./security/submenu/detailsSubMenu.js": 974,
	"./security/submenu/filterSubMenu": 975,
	"./security/submenu/filterSubMenu.js": 975,
	"./security/submenu/recordSubMenu": 976,
	"./security/submenu/recordSubMenu.js": 976,
	"./security/submenu/recordTableSubMenu": 977,
	"./security/submenu/recordTableSubMenu.js": 977,
	"./security/submenu/tableSubMenu": 978,
	"./security/submenu/tableSubMenu.js": 978,
	"./security/totalContingencies/table": 979,
	"./security/totalContingencies/table.js": 979,
	"./security/userSitebuilder/filter": 980,
	"./security/userSitebuilder/filter.js": 980,
	"./security/userSitebuilder/information": 1884,
	"./security/userSitebuilder/information.js": 1884,
	"./security/userSitebuilder/table": 981,
	"./security/userSitebuilder/table.js": 981,
	"./security/userVerification2/filter": 982,
	"./security/userVerification2/filter.js": 982,
	"./security/userVerification2/information": 1885,
	"./security/userVerification2/information.js": 1885,
	"./security/userVerification2/table": 983,
	"./security/userVerification2/table.js": 983,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1886,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1886,
	"./security/usuarioperfil/filterUsuarioPerfil": 984,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 984,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 985,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 985,
	"./security/usuarioperfil/recordUsuarioPerfil": 1887,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1887,
	"./security/usuarioperfil/tableUsuarioPerfil": 986,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 986,
	"./security/usuariosbloqueados/add": 1888,
	"./security/usuariosbloqueados/add.js": 1888,
	"./security/usuariosbloqueados/filter": 987,
	"./security/usuariosbloqueados/filter.js": 987,
	"./security/usuariosbloqueados/table": 988,
	"./security/usuariosbloqueados/table.js": 988,
	"./security/wallets/filter": 989,
	"./security/wallets/filter.js": 989,
	"./security/wallets/table": 990,
	"./security/wallets/table.js": 990,
	"./sessionsReport": 1889,
	"./sessionsReport.js": 1889,
	"./sessionsReport2": 1890,
	"./sessionsReport2.js": 1890,
	"./settings": 1891,
	"./settings.js": 1891,
	"./significantEventsAndAlterations": 1892,
	"./significantEventsAndAlterations.js": 1892,
	"./significantEventsAndAlterations2": 1893,
	"./significantEventsAndAlterations2.js": 1893,
	"./sportsPoolReport": 1894,
	"./sportsPoolReport.js": 1894,
	"./sportsTransactions": 1895,
	"./sportsTransactions.js": 1895,
	"./subMenu": 1896,
	"./subMenu.js": 1896,
	"./subProviders": 1897,
	"./subProviders.js": 1897,
	"./summaryBetsReport": 1898,
	"./summaryBetsReport.js": 1898,
	"./summaryCashFlow": 1899,
	"./summaryCashFlow.js": 1899,
	"./summaryCashFlow2": 1900,
	"./summaryCashFlow2.js": 1900,
	"./summaryCashFlowMachine": 1901,
	"./summaryCashFlowMachine.js": 1901,
	"./tags": 1902,
	"./tags.js": 1902,
	"./taxPaymentsReport": 1903,
	"./taxPaymentsReport.js": 1903,
	"./taxableEarnings": 1904,
	"./taxableEarnings.js": 1904,
	"./teacher/concessionaire/filterConcessionaire": 516,
	"./teacher/concessionaire/filterConcessionaire.js": 516,
	"./teacher/concessionaire/tableConcessionaire": 517,
	"./teacher/concessionaire/tableConcessionaire.js": 517,
	"./teacher/qualifying/filterQualifying": 877,
	"./teacher/qualifying/filterQualifying.js": 877,
	"./teacher/qualifying/tableQualifying": 878,
	"./teacher/qualifying/tableQualifying.js": 878,
	"./teacher/registered-documents/filterRegisteredDocuments": 888,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 888,
	"./teacher/registered-documents/tableRegisteredDocuments": 889,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 889,
	"./termsAndConditions": 1905,
	"./termsAndConditions.js": 1905,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 444,
	"./tools/countries/filter.js": 444,
	"./tools/countries/table": 445,
	"./tools/countries/table.js": 445,
	"./tools/currencyManagement/currencyFilters": 171,
	"./tools/currencyManagement/currencyFilters.js": 171,
	"./tools/currencyManagement/currencyTable": 172,
	"./tools/currencyManagement/currencyTable.js": 172,
	"./tools/translationManager": 1906,
	"./tools/translationManager.js": 1906,
	"./tools/translationManager/filter": 991,
	"./tools/translationManager/filter.js": 991,
	"./tools/translationManager/table": 992,
	"./tools/translationManager/table.js": 992,
	"./tools/uploadImage": 1907,
	"./tools/uploadImage.js": 1907,
	"./top": 1908,
	"./top.js": 1908,
	"./totalContingencies": 1909,
	"./totalContingencies.js": 1909,
	"./transactionReport": 1910,
	"./transactionReport.js": 1910,
	"./transactions": 1911,
	"./transactions.js": 1911,
	"./transactionsByPlayer": 1912,
	"./transactionsByPlayer.js": 1912,
	"./transactionsByPlayerDeposit": 1913,
	"./transactionsByPlayerDeposit.js": 1913,
	"./transactionsByPlayerFirstLevel": 1914,
	"./transactionsByPlayerFirstLevel.js": 1914,
	"./transactionsByPlayerSecondLevel": 1915,
	"./transactionsByPlayerSecondLevel.js": 1915,
	"./trasnfersReport": 1916,
	"./trasnfersReport.js": 1916,
	"./tutorials": 1917,
	"./tutorials.js": 1917,
	"./userAffiliatesAgent": 1918,
	"./userAffiliatesAgent.js": 1918,
	"./userAffiliatesBetShop": 1919,
	"./userAffiliatesBetShop.js": 1919,
	"./userManagement": 1920,
	"./userManagement.js": 1920,
	"./userManagement/userManagement/detailsUserManagement": 995,
	"./userManagement/userManagement/detailsUserManagement.js": 995,
	"./userManagement/userManagement/filterUserManagement": 993,
	"./userManagement/userManagement/filterUserManagement.js": 993,
	"./userManagement/userManagement/recordTableUserManagement": 997,
	"./userManagement/userManagement/recordTableUserManagement.js": 997,
	"./userManagement/userManagement/recordUserManagement": 996,
	"./userManagement/userManagement/recordUserManagement.js": 996,
	"./userManagement/userManagement/tableUserManagement": 994,
	"./userManagement/userManagement/tableUserManagement.js": 994,
	"./userProfile": 1921,
	"./userProfile.js": 1921,
	"./usersSitebuilder": 1922,
	"./usersSitebuilder.js": 1922,
	"./usersVerification": 1923,
	"./usersVerification.js": 1923,
	"./usersVerification/information": 998,
	"./usersVerification/information.js": 998,
	"./usersVerification2": 1924,
	"./usersVerification2.js": 1924,
	"./usersVerificationManagement": 1925,
	"./usersVerificationManagement.js": 1925,
	"./usuarioOnlineResumido": 1926,
	"./usuarioOnlineResumido.js": 1926,
	"./usuariosbloqueados": 1927,
	"./usuariosbloqueados.js": 1927,
	"./verifyAccount": 1928,
	"./verifyAccount.js": 1928,
	"./verifyAccountAgent": 1929,
	"./verifyAccountAgent.js": 1929,
	"./verifyAccountJumio": 1930,
	"./verifyAccountJumio.js": 1930,
	"./wallets": 1931,
	"./wallets.js": 1931,
	"./watchListReport": 1932,
	"./watchListReport.js": 1932,
	"./watchListReport/filterReport": 999,
	"./watchListReport/filterReport.js": 999,
	"./watchListReport/tableReport": 1000,
	"./watchListReport/tableReport.js": 1000,
	"./widgets": 1933,
	"./widgets.js": 1933,
	"./withdrawal": 1934,
	"./withdrawal.js": 1934,
	"./withdrawalReport2": 1935,
	"./withdrawalReport2.js": 1935,
	"./withdrawalRequests": 1936,
	"./withdrawalRequests.js": 1936,
	"./withdrawalRequestsBetShop": 1937,
	"./withdrawalRequestsBetShop.js": 1937,
	"./withdrawalRequestsComissions": 1938,
	"./withdrawalRequestsComissions.js": 1938,
	"./withdrawalRequestsForBetShop": 1939,
	"./withdrawalRequestsForBetShop.js": 1939,
	"./withdrawalRequestsForBetShop2": 1940,
	"./withdrawalRequestsForBetShop2.js": 1940,
	"./withdrawalRequestsRetail": 1941,
	"./withdrawalRequestsRetail.js": 1941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1951;